var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "section-bots",
      class: [
        this.activeSection,
        {
          accordeon:
            (this.activeSection === "new" || this.activeSection === "edit") &&
            !_vm.tabsIsMinimize,
        },
      ],
    },
    [
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true, activeClose: true },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "pages-sidebar head" }, [
        _c("div", { staticClass: "table-title" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("dash.bots.title")))]),
        ]),
      ]),
      _c(
        "vs-popup",
        {
          staticClass: "two-factor-authentification",
          attrs: {
            title: "Authentification à deux facteurs",
            active: _vm.twoFactorPopup,
          },
          on: {
            "update:active": function ($event) {
              _vm.twoFactorPopup = $event
            },
          },
        },
        [
          _c("TwoFactorAuthenticationPopup", {
            attrs: { pageid: _vm.twoFactorPopup, pages: _vm.pages },
            on: { closePopup: _vm.closePopup },
          }),
        ],
        1
      ),
      _c(
        "vs-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: this.activeSection === "main",
              expression: "this.activeSection === 'main'",
            },
          ],
          staticClass: "bots-main",
        },
        [
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              _c(
                "vs-button",
                {
                  staticClass: "btn-large btn-img",
                  attrs: {
                    color: "#303030",
                    "vs-type": "filled",
                    "data-qa": "add-bot",
                  },
                  on: { click: _vm.initBot },
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.$t("dash.bots.add")))]),
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/img/icon_flash_white.svg"),
                      alt: "search",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                { staticClass: "search-page" },
                [
                  _c("vs-input", {
                    staticClass: "inputx",
                    class: { input: true },
                    attrs: {
                      color: "#B20564",
                      "icon-after": "true",
                      icon: "search",
                      placeholder: _vm.$t(
                        "dash.settings.user.label.page_filter"
                      ),
                    },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.pageFilter,
                      callback: function ($$v) {
                        _vm.pageFilter = $$v
                      },
                      expression: "pageFilter",
                    },
                  }),
                ],
                1
              ),
              _vm.botsCount > 0
                ? _c(
                    "div",
                    { staticClass: "bots-wrapper" },
                    [
                      _c("component-multipletable", {
                        key: _vm.keyListBots,
                        attrs: {
                          gridData: _vm.gridData.filter((item) =>
                            _vm.selectedPages.find(
                              (page) =>
                                page.id == item.pages.id &&
                                _vm.checkPageFilter(item.pages)
                            )
                          ),
                          columns: _vm.gridColumns,
                          name: "bots",
                        },
                        on: { edit: _vm.editBot, create: _vm.initBot },
                      }),
                    ],
                    1
                  )
                : _c("div"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vs-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                this.activeSection === "new" || this.activeSection === "edit",
              expression:
                "this.activeSection === 'new' || this.activeSection === 'edit'",
            },
          ],
          staticClass: "bots-new",
          class: [this.activeSection, { accordeon: !_vm.tabsIsMinimize }],
        },
        [
          _c(
            "div",
            {
              staticClass: "pages-sidebar",
              class: { contract: _vm.tabsIsMinimize },
            },
            [
              _c(
                "div",
                {
                  staticClass: "table-title",
                  on: { click: _vm.toggleExpandTabs },
                },
                [_c("p", [_vm._v(_vm._s(_vm.$t("dash.bots.title")))])]
              ),
              _c("div", { staticClass: "show-setting" }, [
                !_vm.tabsIsMinimize
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons expand-btn minimize",
                        on: { click: _vm.toggleExpandTabs },
                      },
                      [_vm._v("navigate_before")]
                    )
                  : _vm._e(),
                _vm.tabsIsMinimize
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons expand-btn maximize",
                        on: { click: _vm.toggleExpandTabs },
                      },
                      [_vm._v("navigate_next")]
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "search-page" },
                [
                  _c("vs-input", {
                    staticClass: "inputx",
                    class: { input: true },
                    attrs: {
                      color: "#B20564",
                      "icon-after": "true",
                      icon: "search",
                      placeholder: _vm.$t(
                        "dash.settings.user.label.page_filter"
                      ),
                    },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                      },
                    },
                    model: {
                      value: _vm.pageFilter,
                      callback: function ($$v) {
                        _vm.pageFilter = $$v
                      },
                      expression: "pageFilter",
                    },
                  }),
                ],
                1
              ),
              _c(
                "ul",
                [
                  _vm._l(_vm.groups, function (group) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.activeSection === "new",
                            expression: "activeSection === 'new'",
                          },
                        ],
                        key: group.id,
                        staticClass: "group",
                        class: [
                          {
                            show: group.show,
                            hide:
                              !_vm.checkPagesInGroup(group) ||
                              _vm.checkGroupFilter(group),
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "group-wrapper",
                            on: {
                              click: function ($event) {
                                return _vm.toggleShowGroup(group)
                              },
                            },
                          },
                          [
                            !group.show
                              ? _c("img", {
                                  staticClass: "show-group",
                                  attrs: {
                                    alt: "show group",
                                    src: require("../../../assets/img/icon-show-group.svg"),
                                  },
                                })
                              : _c("img", {
                                  staticClass: "hide-group",
                                  attrs: {
                                    alt: "hide group",
                                    src: require("../../../assets/img/icon-hide-group.svg"),
                                  },
                                }),
                            _c(
                              "div",
                              { staticClass: "group-content" },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: group.name,
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("p", { staticClass: "group-name" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            `${group.name.substr(0, 14)}${
                                              group.name.length > 15
                                                ? " ..."
                                                : ""
                                            }`
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(
                                      "\n                   \n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          _vm._l(group.pages, function (item) {
                            return _c("div", { key: item }, [
                              _vm.findPage(item)
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "page",
                                      class: [
                                        {
                                          disabled: !_vm.checkLock(
                                            _vm.findPage(item).network
                                          ),
                                          hide: !_vm.checkPageFilter(
                                            _vm.findPage(item)
                                          ),
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "page-wrapper",
                                          class: {
                                            disabled: !_vm.checkLock(
                                              _vm.findPage(item).network
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checkbox" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.bot.page,
                                                    expression: "bot.page",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  id: `page-index-${
                                                    _vm.findPage(item).id
                                                  }`,
                                                  name: "page",
                                                  disabled: !_vm.checkLock(
                                                    _vm.findPage(item).network
                                                  ),
                                                  "data-qa":
                                                    "form-bot-page-selector-" +
                                                    _vm.findPage(item).network,
                                                },
                                                domProps: {
                                                  value: _vm.findPage(item).id,
                                                  checked: _vm._q(
                                                    _vm.bot.page,
                                                    _vm.findPage(item).id
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.addDefaultBotName(
                                                      _vm.findPage(item)
                                                    )
                                                    _vm.getHighlightsInstagramList(
                                                      _vm.findPage(item)
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    _vm.$set(
                                                      _vm.bot,
                                                      "page",
                                                      _vm.findPage(item).id
                                                    )
                                                  },
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "checkmark" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      alt: "checkup",
                                                      src: require("../../../assets/img/icon-checkup.svg"),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "page-content" },
                                            [
                                              _c("page-image-avatar", {
                                                attrs: {
                                                  page: _vm.findPage(item),
                                                },
                                              }),
                                              _c(
                                                "p",
                                                { staticClass: "page-name" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        `${_vm
                                                          .findPage(item)
                                                          .name.substr(0, 14)}${
                                                          _vm.findPage(item)
                                                            .name.length > 15
                                                            ? " ..."
                                                            : ""
                                                        }`
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  _vm._l(_vm.linkedPages, function (item, index) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.activeSection === "new" ||
                              (_vm.activeSection === "edit" &&
                                _vm.bot.page == item.id),
                            expression:
                              "activeSection === 'new' || (activeSection === 'edit' && bot.page == item.id)",
                          },
                        ],
                        key: item.id,
                        staticClass: "page",
                        class: [
                          {
                            disabled: !_vm.checkLock(item.network),
                            hide:
                              !_vm.checkPageFilter(item) ||
                              (_vm.activeSection === "new" &&
                                _vm.pageInGroup(item)),
                          },
                        ],
                      },
                      [
                        _vm.activeSection === "edit" || !_vm.pageInGroup(item)
                          ? _c(
                              "div",
                              {
                                staticClass: "page-wrapper",
                                class: {
                                  disabled: !_vm.checkLock(item.network),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "page-content" },
                                  [
                                    _c("page-image-avatar", {
                                      attrs: { page: item },
                                    }),
                                    _c("p", { staticClass: "page-name" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            `${item.name.substr(0, 14)}${
                                              item.name.length > 15
                                                ? " ..."
                                                : ""
                                            }`
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bot.page,
                                        expression: "bot.page",
                                      },
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: `page-index-${index}`,
                                      name: "page",
                                      disabled: !_vm.checkLock(item.network),
                                      "data-qa":
                                        "form-bot-page-selector-" +
                                        item.network,
                                    },
                                    domProps: {
                                      value: item.id,
                                      checked: _vm._q(_vm.bot.page, item.id),
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.addDefaultBotName(item)
                                        _vm.getHighlightsInstagramList(item)
                                      },
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.bot,
                                          "page",
                                          item.id
                                        )
                                      },
                                    },
                                  }),
                                  _c("span", { staticClass: "checkmark" }, [
                                    _c("img", {
                                      attrs: {
                                        alt: "checkup",
                                        src: require("../../../assets/img/icon-checkup.svg"),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
          _c(
            "vs-col",
            {
              attrs: {
                "vs-justify": "center",
                "vs-align": "center",
                "vs-w": "12",
              },
            },
            [
              _c("form", { attrs: { "data-vv-scope": "bot" } }, [
                _c(
                  "div",
                  { staticClass: "table-title" },
                  [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            `dash.bots.${_vm.editedBotExists ? "edit" : "add"}`
                          )
                        )
                      ),
                    ]),
                    _c(
                      "vs-button",
                      {
                        staticClass: "btn-large btn-cancel",
                        staticStyle: {
                          float: "right",
                          transform: "translateY(-33%)",
                        },
                        attrs: { color: "#303030", "vs-type": "filled" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.cleanData.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "bots-wrapper" },
                  [
                    _vm.activeSection === "new" && !_vm.bot.page
                      ? _c("div", { staticClass: "table-subtitle" }, [
                          _c("p", [_vm._v(_vm._s(_vm.$t("dash.bots.pages")))]),
                        ])
                      : _vm._e(),
                    _vm.activeSection === "new" && !_vm.bot.page
                      ? _c("p", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.$t("dash.bots.pages_subtitle"))),
                        ])
                      : _vm._e(),
                    _vm.bot && _vm.bot.page
                      ? [
                          _c("div", { staticClass: "table-subtitle" }, [
                            _c("p", [_vm._v(_vm._s(_vm.$t("dash.bots.name")))]),
                          ]),
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v(_vm._s(_vm.$t("dash.bots.name_subtitle"))),
                          ]),
                          _c("div", { staticClass: "title box" }, [
                            _c(
                              "div",
                              { staticClass: "title-item title-wrapper" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "input-wrapper" },
                                  [
                                    _c("vs-input", {
                                      staticClass: "inputx",
                                      attrs: {
                                        "vs-size": "large",
                                        type: "text",
                                        name: "name",
                                        placeholder: _vm.$t(
                                          "dash.bots.name_placeholder"
                                        ),
                                      },
                                      on: {
                                        keypress: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          $event.preventDefault()
                                        },
                                        keyup: function ($event) {
                                          _vm.manualName = true
                                        },
                                      },
                                      model: {
                                        value: _vm.bot.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.bot, "name", $$v)
                                        },
                                        expression: "bot.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "table-subtitle",
                              attrs: { id: "sources" },
                            },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.bots.source"))),
                              ]),
                            ]
                          ),
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v(
                              _vm._s(_vm.$t("dash.bots.botType_subtitle"))
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "type box post-content bot-type" },
                            [
                              _c("div", { staticClass: "display-wrapper" }, [
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bot.sourceType,
                                        expression: "bot.sourceType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "custom",
                                      disabled:
                                        _vm.checkEditBotType("custom") ||
                                        !_vm.checkLock("source_choice") ||
                                        _vm.checkLock("partner"),
                                      "data-qa": "form-bot-source-type-custom",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.bot.sourceType,
                                        "custom"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.bot,
                                          "sourceType",
                                          "custom"
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "thumbnail-wrapper",
                                      class: [
                                        {
                                          select:
                                            _vm.bot.sourceType == "custom",
                                        },
                                      ],
                                      style: {
                                        backgroundColor:
                                          !_vm.checkLock("source_choice") ||
                                          _vm.checkLock("partner")
                                            ? "white"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "thumbnail-content",
                                          style: {
                                            filter:
                                              !_vm.checkLock("source_choice") ||
                                              _vm.checkLock("partner")
                                                ? "grayscale(1)"
                                                : "",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "thumbnail-img-wrapper",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../../assets/img/input/custom.svg"),
                                                      alt: "txt",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.botType_custom"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bot.sourceType,
                                        expression: "bot.sourceType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "normal",
                                      disabled: _vm.checkEditBotType("normal"),
                                      "data-qa": "form-bot-source-type-normal",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.bot.sourceType,
                                        "normal"
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.bot,
                                          "sourceType",
                                          "normal"
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "thumbnail-wrapper",
                                      class: [
                                        {
                                          select:
                                            _vm.bot.sourceType == "normal",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "thumbnail-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "thumbnail-img-wrapper",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../../assets/img/input/mashup.svg"),
                                                      alt: "txt",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.botType_mashup"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "thumbnail" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bot.sourceType,
                                        expression: "bot.sourceType",
                                      },
                                    ],
                                    attrs: {
                                      name: "radio-sources",
                                      type: "radio",
                                      value: "none",
                                      disabled: _vm.checkEditBotType("none"),
                                      "data-qa": "form-bot-source-type-none",
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.bot.sourceType,
                                        "none"
                                      ),
                                    },
                                    on: {
                                      click: _vm.manualFrequency,
                                      change: function ($event) {
                                        return _vm.$set(
                                          _vm.bot,
                                          "sourceType",
                                          "none"
                                        )
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "thumbnail-wrapper",
                                      class: [
                                        {
                                          select: _vm.bot.sourceType == "none",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "thumbnail-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "vertical-align" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "thumbnail-img-wrapper",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../../assets/img/input/none.svg"),
                                                      alt: "txt",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "thumbnail-name",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.botType_none"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm.bot.sourceType == "normal"
                            ? [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.$t("dash.bots.topics"))),
                                  ]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("dash.bots.topics_subtitle")
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                this.activeSection !== "main"
                                  ? _c("div", { staticClass: "topics box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "topics-item select-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-subtitle" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.topic_language"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "input-wrapper" },
                                            [
                                              _c(
                                                "vs-select",
                                                {
                                                  model: {
                                                    value: _vm.bot.topics.lang,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.bot.topics,
                                                        "lang",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "bot.topics.lang",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.languages,
                                                  function (item, index) {
                                                    return _c(
                                                      "vs-select-item",
                                                      {
                                                        key: "lang_" + index,
                                                        attrs: {
                                                          value:
                                                            item.value || 0,
                                                          text: item.text || "",
                                                        },
                                                      }
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "topics-item theme-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-subtitle" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../../assets/img/icon_check.svg"),
                                                  alt: "search",
                                                },
                                              }),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.bots.topic")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-wrapper",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "custom-search",
                                                },
                                                [
                                                  this.isEditSection
                                                    ? _c("autocomplete", {
                                                        ref: "theme",
                                                        attrs: {
                                                          disableInput: false,
                                                          source: _vm.themes,
                                                          "results-property":
                                                            "items",
                                                          placeholder: _vm.$t(
                                                            "dash.bots.topic_placeholder"
                                                          ),
                                                          initialDisplay: _vm
                                                            .bot.topics.theme
                                                            ? _vm.bot.topics
                                                                .theme.name
                                                            : "",
                                                        },
                                                        on: {
                                                          selected:
                                                            _vm.setTheme,
                                                          clear: function (
                                                            $event
                                                          ) {
                                                            return _vm.setTheme(
                                                              {}
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _c("autocomplete", {
                                                        ref: "theme",
                                                        attrs: {
                                                          disableInput: !_vm.bot
                                                            .topics.lang
                                                            ? true
                                                            : false,
                                                          source: _vm.themes,
                                                          "results-property":
                                                            "items",
                                                          placeholder: _vm.$t(
                                                            "dash.bots.topic_placeholder"
                                                          ),
                                                          initialDisplay: _vm
                                                            .bot.topics.theme
                                                            ? _vm.bot.topics
                                                                .theme.name
                                                            : "",
                                                        },
                                                        on: {
                                                          selected:
                                                            _vm.setTheme,
                                                          clear: function (
                                                            $event
                                                          ) {
                                                            return _vm.setTheme(
                                                              {}
                                                            )
                                                          },
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "topics-item category-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-subtitle" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.bots.category")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-wrapper",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "custom-search",
                                                },
                                                [
                                                  _c("autocomplete", {
                                                    ref: "category",
                                                    attrs: {
                                                      "request-headers":
                                                        _vm.authHeaders,
                                                      source: _vm.getTopic,
                                                      "results-display": (
                                                        res
                                                      ) =>
                                                        res.name[
                                                          _vm.bot.topics.lang
                                                        ],
                                                      "results-property":
                                                        "categories",
                                                      placeholder: _vm.$t(
                                                        `dash.bots.category_placeholder${
                                                          _vm.bot.topics.theme
                                                            ? ""
                                                            : "_notheme"
                                                        }`
                                                      ),
                                                      initialDisplay: _vm.bot
                                                        .topics.category
                                                        ? _vm.bot.topics
                                                            .category.name
                                                        : "",
                                                      disableInput: !_vm.bot
                                                        .topics.theme
                                                        ? true
                                                        : false,
                                                    },
                                                    on: {
                                                      selected: _vm.setTopic,
                                                      clear: function ($event) {
                                                        return _vm.setTopic({})
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          (this.bot.topics.theme && this.bot.topics.category) ||
                          _vm.bot.sourceType == "custom"
                            ? _c("div", { staticClass: "columns-wrapper" }, [
                                _c(
                                  "div",
                                  { staticClass: "columns left-column" },
                                  [
                                    _c("div", {
                                      staticClass: "table-subtitle",
                                    }),
                                    _c("p", { staticClass: "subtitle" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.bots.sources_subtitle")
                                        )
                                      ),
                                    ]),
                                    _c("div", { staticClass: "source" }, [
                                      _c(
                                        "div",
                                        { staticClass: "box source-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "filters-wrapper" },
                                            [
                                              _vm.bot.sourceType == "normal"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-wrapper search-input",
                                                      class: [
                                                        _vm.allSourcesBtnSelect
                                                          ? "disabled"
                                                          : "",
                                                      ],
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("../../../assets/img/icon_search_pink.png"),
                                                          alt: "search",
                                                        },
                                                      }),
                                                      _c("vs-input", {
                                                        staticClass: "inputx",
                                                        attrs: {
                                                          disabled:
                                                            _vm.allSourcesBtnSelect,
                                                          "vs-size": "large",
                                                          color: "#B20564",
                                                          type: "text",
                                                          name: "search",
                                                          placeholder: _vm.$t(
                                                            "dash.bots.source_placeholder"
                                                          ),
                                                        },
                                                        on: {
                                                          keypress: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            )
                                                              return null
                                                            $event.preventDefault()
                                                          },
                                                          input: _vm.filterList,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.sources.search,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.sources,
                                                              "search",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "sources.search",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.bot.sourceType === "normal"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-wrapper filter-input",
                                                    },
                                                    [
                                                      _c(
                                                        "vs-button",
                                                        {
                                                          staticClass:
                                                            "add-btn btn-img",
                                                          attrs: {
                                                            color: "#2F1937",
                                                            "vs-type": "filled",
                                                            size: "large",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.toggleAllSources()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm.allSourcesBtnSelect
                                                            ? _c("p", [
                                                                _vm._v(
                                                                  "\n                                                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.bots.remove_all_sources"
                                                                      )
                                                                    ) +
                                                                    "\n                                                    "
                                                                ),
                                                              ])
                                                            : _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.bots.add_all_sources"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "source-container" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "source-wrapper scrollable",
                                                },
                                                _vm._l(
                                                  _vm.getSourcesList
                                                    .slice()
                                                    .reverse(),
                                                  function (source, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "source-item",
                                                        class: {
                                                          selected:
                                                            _vm.selectedSources.includes(
                                                              source.uid ||
                                                                source.id
                                                            ) ||
                                                            _vm.allSourcesBtnSelect,
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            size: "30px",
                                                            src: source.logo,
                                                          },
                                                        }),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "source-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                source.name
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        !_vm.allSourcesBtnSelect
                                                          ? [
                                                              !_vm.selectedSources.includes(
                                                                source.uid ||
                                                                  source.id
                                                              )
                                                                ? _c(
                                                                    "vs-button",
                                                                    {
                                                                      staticClass:
                                                                        "add-btn btn-img",
                                                                      attrs: {
                                                                        color:
                                                                          "#2F1937",
                                                                        "vs-type":
                                                                          "filled",
                                                                        size: "large",
                                                                        type: "submit",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.bot.sources.push(
                                                                              source
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "dash.sources.select"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "remove-btn",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.removeSource(
                                                                              source
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "material-icons",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "close"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm.bot.sourceType == "custom"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "add-source source-item",
                                                    },
                                                    [
                                                      _vm.checkLock(
                                                        "sources"
                                                      ) ||
                                                      _vm.checkLock(
                                                        "partner"
                                                      ) ||
                                                      _vm.newSources.length >=
                                                        _vm.checkLock(
                                                          "sources_limit"
                                                        )
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "dash.locked"
                                                                ),
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "vs-button",
                                                                {
                                                                  staticClass:
                                                                    "btn-img btn-large",
                                                                  attrs: {
                                                                    color:
                                                                      "#2F1937",
                                                                    size: "large",
                                                                    "vs-type":
                                                                      "filled",
                                                                    disabled:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.add = true
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "dash.sources.add"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "icon-white",
                                                                    attrs: {
                                                                      src: require("../../../assets/img/icon_rss.svg"),
                                                                      alt: "rss",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c("span", [
                                                                _vm._v(" "),
                                                              ]),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.checkLock(
                                                        "sources"
                                                      ) ||
                                                      _vm.checkLock(
                                                        "partner"
                                                      ) ||
                                                      _vm.newSources.length >=
                                                        _vm.checkLock(
                                                          "sources_limit"
                                                        )
                                                        ? _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-large btn-img",
                                                              attrs: {
                                                                color:
                                                                  "#2F1937",
                                                                "vs-type":
                                                                  "filled",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goToSettings()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.button.changeplan"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("img", {
                                                                attrs: {
                                                                  src: require("../../../assets/img/icon_unlock.svg"),
                                                                  alt: "unlock",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      !_vm.checkLock(
                                                        "sources"
                                                      ) &&
                                                      !_vm.checkLock(
                                                        "partner"
                                                      ) &&
                                                      this.newSources.length <
                                                        _vm.checkLock(
                                                          "sources_limit"
                                                        )
                                                        ? _c(
                                                            "vs-button",
                                                            {
                                                              staticClass:
                                                                "btn-img btn-large",
                                                              attrs: {
                                                                color:
                                                                  "#2F1937",
                                                                size: "large",
                                                                "vs-type":
                                                                  "filled",
                                                                "data-qa":
                                                                  "form-bot-add-source",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.addSource = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.sources.add"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../../assets/img/icon_rss.svg"),
                                                                  alt: "rss",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "vs-popup",
                                                        {
                                                          staticClass:
                                                            "overlay sources-overlay",
                                                          attrs: {
                                                            title: "Source",
                                                            active:
                                                              _vm.addSource,
                                                          },
                                                          on: {
                                                            "update:active":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.addSource =
                                                                  $event
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "component-sources-overlay",
                                                            {
                                                              attrs: {
                                                                mode: "new",
                                                                editSource: "",
                                                              },
                                                              on: {
                                                                "close-source-form":
                                                                  _vm.cleanSourceData,
                                                                fetchSources:
                                                                  _vm.fetchSourcesNew,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "columns right-column" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "table-subtitle" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.bots.inclusion_tags")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("p", { staticClass: "subtitle" }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "dash.bots.inclusion_tags_subtitle"
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "blacklists box" },
                                      [
                                        _c("vue-tags-input", {
                                          attrs: {
                                            tags: _vm.bot.inclusion.tags,
                                            placeholder: _vm.$t(
                                              "dash.bots.inclusion_placeholder"
                                            ),
                                          },
                                          on: {
                                            "tags-changed": (newTags) =>
                                              (_vm.bot.inclusion.tags =
                                                newTags),
                                            "before-deleting-tag": (newTag) =>
                                              _vm.removeCorrespondance(
                                                null,
                                                "inclusion",
                                                newTag
                                              ),
                                          },
                                          model: {
                                            value: _vm.bot.inclusion.tag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bot.inclusion,
                                                "tag",
                                                $$v
                                              )
                                            },
                                            expression: "bot.inclusion.tag",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "table-subtitle" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.bots.blacklist")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("p", { staticClass: "subtitle" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.bots.blacklist_subtitle")
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "blacklists box" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "section-subtitle" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../../assets/img/icon_blacklist.svg"),
                                                alt: "Mashup logo",
                                              },
                                            }),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "dash.bots.blacklist_add"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("vue-tags-input", {
                                          attrs: {
                                            tags: _vm.bot.exclusion.tags,
                                            "autocomplete-items":
                                              _vm.filteredItems,
                                            placeholder: _vm.$t(
                                              "dash.bots.blacklist_placeholder"
                                            ),
                                          },
                                          on: {
                                            "tags-changed": (newTags) =>
                                              (_vm.bot.exclusion.tags =
                                                newTags),
                                            "before-deleting-tag": (newTag) =>
                                              _vm.removeCorrespondance(
                                                null,
                                                "exclusion",
                                                newTag
                                              ),
                                          },
                                          model: {
                                            value: _vm.bot.exclusion.tag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bot.exclusion,
                                                "tag",
                                                $$v
                                              )
                                            },
                                            expression: "bot.exclusion.tag",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ])
                            : _vm.bot.sourceType != "none"
                            ? _c("div", { staticClass: "columns-wrapper" }, [
                                _c(
                                  "div",
                                  { staticClass: "columns left-column" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "table-subtitle" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.$t("dash.bots.source"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("p", { staticClass: "subtitle" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.sources_subtitle_no_topic"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          (this.selectedPage.network === "linkedin" &&
                            _vm.activeLinkedinCredentials) ||
                          (this.selectedPage.network === "instagram" &&
                            _vm.activeInstagramStories) ||
                          (this.selectedPage.network === "facebook" &&
                            !_vm.isProd() &&
                            _vm.activeFacebookCredentials)
                            ? _c("div", { attrs: { id: "connection" } }, [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.bots.connection"))
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.bots.connection_subtitle")
                                    )
                                  ),
                                ]),
                                _vm.linkedinConnected === "locked"
                                  ? _c("div", [
                                      _c(
                                        "p",
                                        { staticClass: "connect-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.story.account.locked"
                                              )
                                            ) +
                                              " " +
                                              _vm._s(
                                                new Date(
                                                  _vm.selectedPage.story_config.lock
                                                ).toLocaleString()
                                              )
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm.linkedinConnected === "connected"
                                  ? _c(
                                      "div",
                                      [
                                        !_vm.noMatchId
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "connect-success",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.connected_direct"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "connect-warning",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.bots.connected_match"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                        _vm.analysts && _vm.analysts.length
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "connect-warning",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.analysts"
                                                    ) +
                                                      " " +
                                                      _vm.analysts.join(", ")
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.usernamePageDiff
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "connect-warning",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .$t(
                                                        "dash.bots.username_diff_insta"
                                                      )
                                                      .replace(
                                                        "d'utilisateur",
                                                        _vm.usernamePageDiff
                                                      ) +
                                                      " " +
                                                      _vm.selectedPage.name
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.connectionReturn
                                          ? _c(
                                              "vs-button",
                                              {
                                                staticClass:
                                                  "modify-btn-linkedin",
                                                on: {
                                                  click: () =>
                                                    (_vm.linkedinModify = true),
                                                },
                                              },
                                              [_vm._v("Modifier")]
                                            )
                                          : _vm._e(),
                                        !_vm.connectionReturn ||
                                        _vm.usernamePageDiff
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.pages.disconnect_conciergerie"
                                                  ),
                                                  position: "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "disconnect-conciergerie",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.disconnectConciergerie(
                                                          _vm.selectedPage.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.header.nav.logout"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("span", [_vm._v(" ")]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm.noMatchId
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "connect-warning" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.bots.connected_match"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "vs-button",
                                          {
                                            staticClass: "modify-btn-linkedin",
                                            on: {
                                              click: () =>
                                                (_vm.noMatchId = false),
                                            },
                                          },
                                          [_vm._v("OK")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "conciergerie-instruction",
                                      },
                                      [
                                        ["linkedin", "facebook"].includes(
                                          _vm.selectedPage.network
                                        )
                                          ? _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "conciergerie-instruction-title bot-version",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedPage.network ===
                                                      "facebook"
                                                      ? _vm.$t(
                                                          "dash.bots.connection_method_facebook"
                                                        )
                                                      : _vm.$t(
                                                          "dash.bots.connection_method_1"
                                                        )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        ["linkedin", "facebook"].includes(
                                          _vm.selectedPage.network
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "conciergerie-instruction-method method-1 bot-version",
                                              },
                                              [
                                                !_vm.extension
                                                  ? _c(
                                                      "vs-button",
                                                      {
                                                        style: {
                                                          width: "250px",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.useExtension,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `dash.bots.connection_open_extension`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                !_vm.extension
                                                  ? _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.extension_explication_1"
                                                          )
                                                        )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                !_vm.extension
                                                  ? _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            `dash.bots.extension_explication_2_${_vm.selectedPage.network}`
                                                          )
                                                        ),
                                                      },
                                                    })
                                                  : _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            `dash.bots.extension_explication_3_${_vm.selectedPage.network}`
                                                          )
                                                        ),
                                                      },
                                                    }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        ["linkedin"].includes(
                                          _vm.selectedPage.network
                                        )
                                          ? _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "conciergerie-instruction-title bot-version",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.connection_method_2"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        ["linkedin", "instagram"].includes(
                                          _vm.selectedPage.network
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "conciergerie-instruction-method method-2",
                                                style: {
                                                  display: "flex",
                                                  gap: "30px",
                                                  marginBottom: "20px",
                                                },
                                              },
                                              [
                                                _c("vs-input", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      `dash.bots.connection_email${
                                                        this.selectedPage
                                                          .network ===
                                                        "instagram"
                                                          ? "_username"
                                                          : ""
                                                      }`
                                                    ),
                                                    placeholder: _vm.$t(
                                                      `dash.bots.connection_email${
                                                        this.selectedPage
                                                          .network ===
                                                        "instagram"
                                                          ? "_username"
                                                          : ""
                                                      }`
                                                    ),
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      )
                                                        return null
                                                      $event.preventDefault()
                                                      return _vm.connectLinkedin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                    submit: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.connectLinkedin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.linkedinUsername,
                                                    callback: function ($$v) {
                                                      _vm.linkedinUsername = $$v
                                                    },
                                                    expression:
                                                      "linkedinUsername",
                                                  },
                                                }),
                                                _c("vs-input", {
                                                  attrs: {
                                                    type: _vm.showPass
                                                      ? "text"
                                                      : "password",
                                                    label: _vm.$t(
                                                      "dash.bots.connection_password"
                                                    ),
                                                    placeholder: _vm.$t(
                                                      "dash.bots.connection_password"
                                                    ),
                                                  },
                                                  on: {
                                                    submit: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.connectLinkedin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      )
                                                        return null
                                                      $event.preventDefault()
                                                      return _vm.connectLinkedin.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.linkedinPassword,
                                                    callback: function ($$v) {
                                                      _vm.linkedinPassword = $$v
                                                    },
                                                    expression:
                                                      "linkedinPassword",
                                                  },
                                                }),
                                                _c("vs-button", {
                                                  staticClass: "btn-eye",
                                                  attrs: {
                                                    type: "fill",
                                                    icon: _vm.showPass
                                                      ? "visibility_off"
                                                      : "visibility",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showPass =
                                                        !_vm.showPass
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        ["linkedin"].includes(
                                          this.selectedPage.network
                                        )
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "warning-two-auth",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.warning_two_auth"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.selectedPage.network ===
                                          "instagram" &&
                                        _vm.instagramPagesUsernames
                                          .filter(
                                            (e) =>
                                              e.name !== _vm.selectedPage.name
                                          )
                                          .map((e) => e.username)
                                          .includes(_vm.linkedinUsername)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "username-conciergerie-diff",
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.bots.username_used_insta"
                                                      ) +
                                                        _vm.instagramPagesUsernames.find(
                                                          (e) =>
                                                            e.username ===
                                                            _vm.linkedinUsername
                                                        ).name
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "vs-con-loading__container replace-username-btn",
                                                    staticStyle: {
                                                      "text-transform": "none",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        !_vm.linkedinUsername ||
                                                        !_vm.linkedinPassword,
                                                      id: "linkedin-direct-loading",
                                                      color: "primary",
                                                      type: "filled",
                                                    },
                                                    on: {
                                                      click: () =>
                                                        (_vm.linkedinUsername =
                                                          ""),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.button.cancel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                              ou\n                              "
                                                ),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "vs-con-loading__container replace-username-btn",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.linkedinUsername ||
                                                        !_vm.linkedinPassword,
                                                      id: "linkedin-direct-loading",
                                                      color: "primary",
                                                      type: "filled",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.connectLinkedin,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.username_diff_insta_btn1"
                                                        ) + _vm.linkedinUsername
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm.selectedPage.network ===
                                              "instagram" &&
                                            _vm.linkedinUsername &&
                                            _vm.selectedPage.name.trim() !==
                                              _vm.linkedinUsername.trim()
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "username-conciergerie-diff",
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.bots.username_diff_insta"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "vs-con-loading__container replace-username-btn",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.linkedinUsername ||
                                                        !_vm.linkedinPassword,
                                                      id: "linkedin-direct-loading",
                                                      color: "primary",
                                                      type: "filled",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.connectLinkedin,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.username_diff_insta_btn1"
                                                        ) + _vm.linkedinUsername
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                              ou\n                              "
                                                ),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "vs-con-loading__container replace-username-btn",
                                                    staticStyle: {
                                                      "text-transform": "none",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        !_vm.linkedinUsername ||
                                                        !_vm.linkedinPassword,
                                                      id: "linkedin-direct-loading",
                                                      color: "primary",
                                                      type: "filled",
                                                    },
                                                    on: {
                                                      click: () =>
                                                        _vm.connectLinkedin(
                                                          true
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.username_diff_insta_btn2"
                                                        ) +
                                                          _vm.selectedPage.name
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : ["linkedin", "instagram"].includes(
                                              _vm.selectedPage.network
                                            )
                                          ? _c(
                                              "vs-button",
                                              {
                                                staticClass:
                                                  "vs-con-loading__container",
                                                attrs: {
                                                  id: "linkedin-direct-loading",
                                                  color: "primary",
                                                  type: "filled",
                                                },
                                                on: {
                                                  click: _vm.connectLinkedin,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.connect_direct"
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "column" }, [
                            _c("div", { staticClass: "left" }, [
                              _c("div", { staticClass: "table-subtitle" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.bots.add_hashtag"))
                                  ),
                                ]),
                              ]),
                              _c("p", { staticClass: "subtitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.bots.add_hashtag_subtitle")
                                  )
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.hideEmojiPickerPrefix,
                                      expression: "hideEmojiPickerPrefix",
                                    },
                                  ],
                                  staticClass: "hashtags prefix box",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "textarea-emoji-picker" },
                                    [
                                      _c("picker", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showEmojiPickerPrefix,
                                            expression: "showEmojiPickerPrefix",
                                          },
                                        ],
                                        attrs: {
                                          data: _vm.emojiIndex,
                                          title: "Pick your emoji...",
                                          emoji: "point_up",
                                        },
                                        on: { select: _vm.addEmojiPrefix },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji-trigger",
                                          class: {
                                            triggered:
                                              _vm.showEmojiPickerPrefix,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleEmojiPicker(
                                                "prefix"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                width: "20px",
                                                height: "20px",
                                              },
                                              attrs: { viewBox: "0 0 24 24" },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#888888",
                                                  d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("vs-textarea", {
                                        ref: "inputHashtagPrefix",
                                        attrs: {
                                          label: _vm.$t(
                                            "dash.bots.hashtags_prefix_label"
                                          ),
                                          id: "hashtag-prefix",
                                          placeholder: _vm.$t(
                                            "dash.bots.hashtags_prefix_placeholder"
                                          ),
                                          "data-qa": "form-bot-add-prefix",
                                        },
                                        model: {
                                          value: _vm.bot.hashtagPrefix,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bot,
                                              "hashtagPrefix",
                                              $$v
                                            )
                                          },
                                          expression: "bot.hashtagPrefix",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.hideEmojiPickerSuffix,
                                      expression: "hideEmojiPickerSuffix",
                                    },
                                  ],
                                  staticClass: "hashtags suffix box",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "textarea-emoji-picker" },
                                    [
                                      _c("picker", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showEmojiPickerSuffix,
                                            expression: "showEmojiPickerSuffix",
                                          },
                                        ],
                                        attrs: {
                                          data: _vm.emojiIndex,
                                          title: "Pick your emoji...",
                                          emoji: "point_up",
                                        },
                                        on: { select: _vm.addEmojiSuffix },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji-trigger",
                                          class: {
                                            triggered:
                                              _vm.showEmojiPickerSuffix,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleEmojiPicker(
                                                "suffix"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                width: "20px",
                                                height: "20px",
                                              },
                                              attrs: { viewBox: "0 0 24 24" },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#888888",
                                                  d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("vs-textarea", {
                                        ref: "inputHashtagSuffix",
                                        attrs: {
                                          label: _vm.$t(
                                            "dash.bots.hashtags_suffix_label"
                                          ),
                                          id: "hashtag-suffix",
                                          placeholder: _vm.$t(
                                            "dash.bots.hashtags_suffix_placeholder"
                                          ),
                                          "data-qa": "form-bot-add-suffix",
                                        },
                                        model: {
                                          value: _vm.bot.hashtag,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.bot, "hashtag", $$v)
                                          },
                                          expression: "bot.hashtag",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            !_vm.getBoardPagePinterest
                              ? _c("div", { staticClass: "right" }, [
                                  _c("div", { staticClass: "table-subtitle" }, [
                                    [
                                      "twitter",
                                      "facebook",
                                      "linkedin",
                                      "instagram",
                                    ].includes(_vm.selectedPage.network)
                                      ? _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.mentions_hashtagsAuto"
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("dash.bots.hashtagsAuto")
                                            )
                                          ),
                                        ]),
                                  ]),
                                  [
                                    "twitter",
                                    "facebook",
                                    "linkedin",
                                    "instagram",
                                  ].includes(_vm.selectedPage.network)
                                    ? _c("p", { staticClass: "subtitle" }, [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.mentions_subtitle"
                                              )
                                            ) +
                                            "\n                              "
                                        ),
                                        _vm.bot.mentions.length > 0 &&
                                        _vm.bot.mentions[0].mention != ""
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.bot.mentions.length
                                                  ) +
                                                  " mentions)"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  [
                                    "twitter",
                                    "facebook",
                                    "linkedin",
                                    "instagram",
                                  ].includes(_vm.selectedPage.network)
                                    ? _c(
                                        "div",
                                        { staticClass: "mentions" },
                                        [
                                          _c(
                                            "ul",
                                            _vm._l(
                                              _vm.bot.mentions,
                                              function (values, key) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: key,
                                                    staticClass: "row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "click-outside",
                                                            rawName:
                                                              "v-click-outside",
                                                            value:
                                                              _vm.closeAutoMentions,
                                                            expression:
                                                              "closeAutoMentions",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "mention-content",
                                                      },
                                                      [
                                                        _c("vs-input", {
                                                          staticClass:
                                                            "inputx mention",
                                                          attrs: {
                                                            "vs-size": "large",
                                                            type: "text",
                                                            name: "mention",
                                                            icon: "@",
                                                            placeholder: _vm.$t(
                                                              `dash.bots.mention_${
                                                                [
                                                                  "linkedin",
                                                                  "instagram",
                                                                ].includes(
                                                                  _vm
                                                                    .selectedPage
                                                                    .network
                                                                ) &&
                                                                _vm.linkedinConnected !==
                                                                  "connected"
                                                                  ? "url"
                                                                  : "name"
                                                              }_placeholder`
                                                            ),
                                                            "data-qa":
                                                              "form-bot-add-mention",
                                                          },
                                                          on: {
                                                            keypress: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                !$event.type.indexOf(
                                                                  "key"
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              )
                                                                return null
                                                              $event.preventDefault()
                                                            },
                                                            focus: function (
                                                              $event
                                                            ) {
                                                              return _vm.showAutoMentions(
                                                                key
                                                              )
                                                            },
                                                            keyup: function (
                                                              $event
                                                            ) {
                                                              return _vm.searchMentions(
                                                                key
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              values.mention,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                values,
                                                                "mention",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "values.mention",
                                                          },
                                                        }),
                                                        _vm.openAutoMentions &&
                                                        _vm.autoMentions[key] &&
                                                        _vm.autoMentions[key]
                                                          .length > 0 &&
                                                        values.mention.length >=
                                                          2
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: `${key}-${values.mention}`,
                                                                staticClass:
                                                                  "auto-mentions row box",
                                                                class:
                                                                  _vm
                                                                    .selectedPage
                                                                    .network,
                                                                attrs: {
                                                                  "data-qa":
                                                                    "form-bot-select-auto-mentions",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "ul",
                                                                  _vm._l(
                                                                    _vm
                                                                      .autoMentions[
                                                                      key
                                                                    ],
                                                                    function (
                                                                      mention,
                                                                      index
                                                                    ) {
                                                                      return _c(
                                                                        "li",
                                                                        {
                                                                          key: index,
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.replaceMention(
                                                                                      key,
                                                                                      mention
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              mention.image
                                                                                ? _c(
                                                                                    "img",
                                                                                    {
                                                                                      staticClass:
                                                                                        "image",
                                                                                      attrs:
                                                                                        {
                                                                                          alt: mention.name,
                                                                                          src: mention.image,
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "image",
                                                                                    }
                                                                                  ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "content",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "name",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          mention.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm
                                                                                    .selectedPage
                                                                                    .network ==
                                                                                  "twitter"
                                                                                    ? _c(
                                                                                        "img",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              alt: "verified account",
                                                                                              src: require("../../../assets/img/validated-twitter.png"),
                                                                                            },
                                                                                        }
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _vm
                                                                                    .selectedPage
                                                                                    .network ==
                                                                                  "facebook"
                                                                                    ? _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "screen_name id",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              mention.id
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "screen_name",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "@" +
                                                                                              _vm._s(
                                                                                                _vm
                                                                                                  .selectedPage
                                                                                                  .network ==
                                                                                                  "twitter"
                                                                                                  ? mention.screen_name
                                                                                                  : _vm
                                                                                                      .selectedPage
                                                                                                      .network ==
                                                                                                    "instagram"
                                                                                                  ? mention.id
                                                                                                  : mention.name
                                                                                              )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                  _vm
                                                                                    .selectedPage
                                                                                    .network ==
                                                                                  "twitter"
                                                                                    ? _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "description",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              mention.description
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c("vue-tags-input", {
                                                      staticClass:
                                                        "correspondences",
                                                      attrs: {
                                                        tags: values.correspondences,
                                                        placeholder: _vm.$t(
                                                          "dash.bots.mention_correspondences_placeholder"
                                                        ),
                                                        "data-qa":
                                                          "form-bot-add-mention-correspondance",
                                                      },
                                                      on: {
                                                        "before-adding-tag": (
                                                          newTag
                                                        ) =>
                                                          _vm.checkAndAddCorrespondance(
                                                            key,
                                                            "mention",
                                                            newTag
                                                          ),
                                                        "before-deleting-tag": (
                                                          newTag
                                                        ) =>
                                                          _vm.removeCorrespondance(
                                                            key,
                                                            "mention",
                                                            newTag
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          values.correspondence,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            values,
                                                            "correspondence",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "values.correspondence",
                                                      },
                                                    }),
                                                    _c("vs-button", {
                                                      staticClass: "remove",
                                                      attrs: {
                                                        color: "#303030",
                                                        icon: "remove",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeMention(
                                                            key
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "vs-button",
                                            {
                                              attrs: { color: "#303030" },
                                              on: { click: _vm.addMention },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "dash.bots.mentions.add.new"
                                                    )
                                                  ) +
                                                  "\n                              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("p", { staticClass: "subtitle" }, [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.hashtagsAuto_subtitle"
                                          )
                                        ) +
                                        "\n                              "
                                    ),
                                    _vm.bot.hashtagsAuto.length > 0 &&
                                    _vm.bot.hashtagsAuto[0].hashtag != ""
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.bot.hashtagsAuto.length
                                              ) +
                                              " #hashtags)"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "hashtags-auto" },
                                    [
                                      _c(
                                        "ul",
                                        _vm._l(
                                          _vm.bot.hashtagsAuto,
                                          function (values, key) {
                                            return _c(
                                              "li",
                                              { key: key, staticClass: "row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hashtag-content",
                                                  },
                                                  [
                                                    _c("vs-input", {
                                                      staticClass:
                                                        "inputx hashtag",
                                                      attrs: {
                                                        "vs-size": "large",
                                                        type: "text",
                                                        name: "hashtag",
                                                        icon: "#",
                                                        placeholder: _vm.$t(
                                                          "dash.bots.hashtags_name_placeholder"
                                                        ),
                                                        "data-qa":
                                                          "form-bot-add-hashtag",
                                                      },
                                                      on: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            !$event.type.indexOf(
                                                              "key"
                                                            ) &&
                                                            _vm._k(
                                                              $event.keyCode,
                                                              "enter",
                                                              13,
                                                              $event.key,
                                                              "Enter"
                                                            )
                                                          )
                                                            return null
                                                          $event.preventDefault()
                                                        },
                                                      },
                                                      model: {
                                                        value: values.hashtag,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            values,
                                                            "hashtag",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "values.hashtag",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c("vue-tags-input", {
                                                  staticClass:
                                                    "correspondences",
                                                  attrs: {
                                                    tags: values.correspondences,
                                                    placeholder: _vm.$t(
                                                      "dash.bots.hashtag_correspondences_placeholder"
                                                    ),
                                                    "data-qa":
                                                      "form-bot-add-hashtag-correspondance",
                                                  },
                                                  on: {
                                                    "before-adding-tag": (
                                                      newTag
                                                    ) =>
                                                      _vm.checkAndAddCorrespondance(
                                                        key,
                                                        "hashtag",
                                                        newTag
                                                      ),
                                                    "before-deleting-tag": (
                                                      newTag
                                                    ) =>
                                                      _vm.removeCorrespondance(
                                                        key,
                                                        "hashtag",
                                                        newTag
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      values.correspondence,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        values,
                                                        "correspondence",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "values.correspondence",
                                                  },
                                                }),
                                                _c("vs-button", {
                                                  staticClass: "remove",
                                                  attrs: {
                                                    color: "#303030",
                                                    icon: "remove",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeHashtag(
                                                        key
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: { color: "#303030" },
                                          on: { click: _vm.addHashtag },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.bots.hashtags.add.new"
                                                )
                                              ) +
                                              "\n                              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            _c("div", { staticClass: "table-subtitle" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("dash.bots.utm")) +
                                    "\n                                "
                                ),
                                !_vm.showUtmConfig &&
                                (!_vm.bot.utm || !_vm.bot.utm.length)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "material-icons",
                                        on: {
                                          click: function ($event) {
                                            _vm.showUtmConfig = true
                                          },
                                        },
                                      },
                                      [_vm._v("arrow_drop_down")]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm.showUtmConfig ||
                            (_vm.bot.utm && _vm.bot.utm.length)
                              ? _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.bots.utm_subtitle"))
                                  ),
                                ])
                              : _vm._e(),
                            _vm.showUtmConfig ||
                            (_vm.bot.utm && _vm.bot.utm.length)
                              ? _c("div", { staticClass: "title box" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-item title-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-wrapper" },
                                        [
                                          _c("vs-input", {
                                            staticClass: "inputx",
                                            attrs: {
                                              disabled: "",
                                              "vs-size": "large",
                                              type: "text",
                                              name: "utm",
                                              placeholder: _vm.$t(
                                                "dash.bots.utm_placeholder"
                                              ),
                                            },
                                            on: {
                                              keypress: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                $event.preventDefault()
                                              },
                                            },
                                            model: {
                                              value: _vm.bot.utm,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.bot, "utm", $$v)
                                              },
                                              expression: "bot.utm",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.showUtmConfig ||
                            (_vm.bot.utm && _vm.bot.utm.length)
                              ? _c("div", { staticClass: "title box utm" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-item title-wrapper" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-wrapper" },
                                        [
                                          _c(
                                            "vs-row",
                                            [
                                              _c(
                                                "vs-col",
                                                {
                                                  attrs: {
                                                    "vs-type": "flex",
                                                    "vs-justify": "center",
                                                    "vs-align": "center",
                                                    "vs-w": "4",
                                                  },
                                                },
                                                [
                                                  _c("vs-input", {
                                                    staticClass: "inputx",
                                                    attrs: {
                                                      label: "utm_campaign",
                                                      type: "text",
                                                      name: "campaign",
                                                      placeholder: _vm.$t(
                                                        "dash.bots.utm_placeholder"
                                                      ),
                                                      value:
                                                        _vm.bot.utmCampaign,
                                                    },
                                                    on: {
                                                      keypress: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        $event.preventDefault()
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeUtmValue(
                                                          "utm_campaign",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "vs-col",
                                                {
                                                  attrs: {
                                                    "vs-type": "flex",
                                                    "vs-justify": "center",
                                                    "vs-align": "center",
                                                    "vs-w": "4",
                                                  },
                                                },
                                                [
                                                  _c("vs-input", {
                                                    staticClass: "inputx",
                                                    attrs: {
                                                      label: "utm_medium",
                                                      type: "text",
                                                      name: "medium",
                                                      placeholder: _vm.$t(
                                                        "dash.bots.utm_placeholder"
                                                      ),
                                                      value: _vm.bot.utmMedium,
                                                    },
                                                    on: {
                                                      keypress: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        $event.preventDefault()
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeUtmValue(
                                                          "utm_medium",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "vs-col",
                                                {
                                                  attrs: {
                                                    "vs-type": "flex",
                                                    "vs-justify": "center",
                                                    "vs-align": "center",
                                                    "vs-w": "4",
                                                  },
                                                },
                                                [
                                                  _c("vs-input", {
                                                    staticClass: "inputx",
                                                    attrs: {
                                                      label: "utm_source",
                                                      type: "text",
                                                      name: "source",
                                                      placeholder: _vm.$t(
                                                        "dash.bots.utm_placeholder"
                                                      ),
                                                      value: _vm.bot.utmSource,
                                                      "data-qa":
                                                        "form-bot-utm-source",
                                                    },
                                                    on: {
                                                      keypress: function (
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        )
                                                          return null
                                                        $event.preventDefault()
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.changeUtmValue(
                                                          "utm_source",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          [
                            "twitter",
                            "instagram",
                            "facebook",
                            "linkedin",
                            "threads",
                            "bluesky",
                            "pinterest",
                          ].includes(_vm.selectedPage.network)
                            ? _c("div", { staticClass: "post-type" }, [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [_vm._v("Type de publication")]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    "\n                            Sélectionnez le type de post que vous souhaitez poster et la répartition\n                          "
                                  ),
                                ]),
                                !["google", "telegram", "pinterest"].includes(
                                  _vm.selectedPage.network
                                )
                                  ? _c("div", { staticClass: "post-content" }, [
                                      _c(
                                        "div",
                                        { staticClass: "display-wrapper" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "thumbnail" },
                                            [
                                              "radio" === "checkbox"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bot.posts.mode,
                                                        expression:
                                                          "bot.posts.mode",
                                                      },
                                                    ],
                                                    attrs: {
                                                      name: "post-mode",
                                                      value: "standard",
                                                      type: "checkbox",
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.bot.posts.mode
                                                      )
                                                        ? _vm._i(
                                                            _vm.bot.posts.mode,
                                                            "standard"
                                                          ) > -1
                                                        : _vm.bot.posts.mode,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              _vm.bot.posts
                                                                .mode,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v =
                                                                "standard",
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.bot.posts,
                                                                  "mode",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.bot.posts,
                                                                  "mode",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.bot.posts,
                                                              "mode",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                        (_) => {
                                                          _vm.$forceUpdate()
                                                          _vm.modeInsta =
                                                            _vm.bot.posts.mode
                                                          _vm.bot.posts.mixAutoPost = 0
                                                        },
                                                      ],
                                                    },
                                                  })
                                                : "radio" === "radio"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bot.posts.mode,
                                                        expression:
                                                          "bot.posts.mode",
                                                      },
                                                    ],
                                                    attrs: {
                                                      name: "post-mode",
                                                      value: "standard",
                                                      type: "radio",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.bot.posts.mode,
                                                        "standard"
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.bot.posts,
                                                            "mode",
                                                            "standard"
                                                          )
                                                        },
                                                        (_) => {
                                                          _vm.$forceUpdate()
                                                          _vm.modeInsta =
                                                            _vm.bot.posts.mode
                                                          _vm.bot.posts.mixAutoPost = 0
                                                        },
                                                      ],
                                                    },
                                                  })
                                                : _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bot.posts.mode,
                                                        expression:
                                                          "bot.posts.mode",
                                                      },
                                                    ],
                                                    attrs: {
                                                      name: "post-mode",
                                                      value: "standard",
                                                      type: "radio",
                                                    },
                                                    domProps: {
                                                      value: _vm.bot.posts.mode,
                                                    },
                                                    on: {
                                                      change: (_) => {
                                                        _vm.$forceUpdate()
                                                        _vm.modeInsta =
                                                          _vm.bot.posts.mode
                                                        _vm.bot.posts.mixAutoPost = 0
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.bot.posts,
                                                          "mode",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "thumbnail-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "thumbnail-content",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "vertical-align",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "thumbnail-img-wrapper thumbnail-img-wrapper-instagram",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  src: require("../../../assets/img/input/instagram-post.svg"),
                                                                  alt: "txt",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "thumbnail-name",
                                                            },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Standard " +
                                                                    _vm._s(
                                                                      [
                                                                        "facebook",
                                                                        "linkedin",
                                                                        "twitter",
                                                                      ].includes(
                                                                        _vm
                                                                          .selectedPage
                                                                          .network
                                                                      ) &&
                                                                        _vm.checkLock(
                                                                          "conciergerie"
                                                                        )
                                                                        ? _vm
                                                                            .labelCursorRangeTypePost[
                                                                            _vm
                                                                              .bot
                                                                              .posts
                                                                              .mixAutoPost
                                                                          ]
                                                                        : ""
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.selectedPage.network !==
                                          "instagram"
                                            ? _c(
                                                "div",
                                                { staticClass: "thumbnail" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bot.posts.mode,
                                                        expression:
                                                          "bot.posts.mode",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "radio",
                                                      name: "post-mode",
                                                      value: "image",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.bot.posts.mode,
                                                        "image"
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.bot.posts,
                                                            "mode",
                                                            "image"
                                                          )
                                                        },
                                                        (_) => {
                                                          _vm.$forceUpdate()
                                                          ;(_vm.modeInsta =
                                                            _vm.bot.posts.mode),
                                                            (_vm.bot.posts.mixAutoPost = 18)
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "thumbnail-wrapper",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumbnail-content",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "vertical-align",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "thumbnail-img-wrapper thumbnail-img-wrapper-instagram",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: require("../../../assets/img/input/instagram-post.svg"),
                                                                      alt: "txt",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "thumbnail-name",
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      "Image " +
                                                                        _vm._s(
                                                                          [
                                                                            "facebook",
                                                                            "linkedin",
                                                                            "twitter",
                                                                          ].includes(
                                                                            _vm
                                                                              .selectedPage
                                                                              .network
                                                                          ) &&
                                                                            _vm.checkLock(
                                                                              "conciergerie"
                                                                            )
                                                                            ? _vm
                                                                                .labelCursorRangeTypePost[
                                                                                _vm
                                                                                  .labelCursorRangeTypePost
                                                                                  .length -
                                                                                  1 -
                                                                                  _vm
                                                                                    .bot
                                                                                    .posts
                                                                                    .mixAutoPost
                                                                              ]
                                                                            : ""
                                                                        )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.selectedPage.network ===
                                            "instagram" &&
                                          _vm.linkedinConnected ===
                                            "connected" &&
                                          _vm.activeInstagramStories
                                            ? _c(
                                                "div",
                                                { staticClass: "thumbnail" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bot.posts.mode,
                                                        expression:
                                                          "bot.posts.mode",
                                                      },
                                                    ],
                                                    attrs: {
                                                      type: "radio",
                                                      name: "post-mode",
                                                      value: "story",
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.bot.posts.mode,
                                                        "story"
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.bot.posts,
                                                            "mode",
                                                            "story"
                                                          )
                                                        },
                                                        (_) => {
                                                          _vm.$forceUpdate()
                                                          _vm.modeInsta =
                                                            _vm.bot.posts.mode
                                                        },
                                                      ],
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "thumbnail-wrapper",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumbnail-content",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "vertical-align",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "thumbnail-img-wrapper thumbnail-img-wrapper-instagram",
                                                                },
                                                                [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: require("../../../assets/img/input/instagram-story.svg"),
                                                                      alt: "txt",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "thumbnail-name",
                                                                },
                                                                [
                                                                  _c("p", [
                                                                    _vm._v(
                                                                      "Story Instagram"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.bot.posts.mode == "story"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "reshare-story-on-facebook",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "table-subtitle" },
                                          [
                                            _c("p", [
                                              _vm._v("Partage sur Facebook"),
                                            ]),
                                          ]
                                        ),
                                        _c("p", { staticClass: "subtitle" }, [
                                          _vm._v(
                                            "\n                              Souhaitez-vous partager vos stories sur Facebook ?\n                            "
                                          ),
                                        ]),
                                        _c("div", { staticClass: "limit" }, [
                                          _c(
                                            "div",
                                            { staticClass: "limit-wrapper" },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      _vm.shareStoryOnFacebook,
                                                  },
                                                  attrs: { "vs-value": true },
                                                  model: {
                                                    value:
                                                      _vm.shareStoryOnFacebook,
                                                    callback: function ($$v) {
                                                      _vm.shareStoryOnFacebook =
                                                        $$v
                                                    },
                                                    expression:
                                                      "shareStoryOnFacebook",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        Oui\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      !_vm.shareStoryOnFacebook,
                                                  },
                                                  attrs: { "vs-value": false },
                                                  model: {
                                                    value:
                                                      _vm.shareStoryOnFacebook,
                                                    callback: function ($$v) {
                                                      _vm.shareStoryOnFacebook =
                                                        $$v
                                                    },
                                                    expression:
                                                      "shareStoryOnFacebook",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        Non\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                ["facebook", "linkedin", "twitter"].includes(
                                  _vm.selectedPage.network
                                ) && _vm.checkLock("conciergerie")
                                  ? _c(
                                      "div",
                                      { staticClass: "select-range" },
                                      [
                                        _c("InputRange", {
                                          attrs: {
                                            popUpIsActive: false,
                                            value: _vm.bot.posts.mixAutoPost,
                                            valueMin: 0,
                                            valueMax: 18,
                                            onChange:
                                              _vm.handleChangeTypeDivisionByInputRange,
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "range-label" },
                                          [
                                            _c("span", [
                                              _vm._v("Post standard"),
                                            ]),
                                            _c("span", [_vm._v("Post image")]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.bot.posts.mode === "image" ||
                                (_vm.bot.posts.mode === "standard" &&
                                  ["instagram", "pinterest"].includes(
                                    _vm.selectedPage.network
                                  ))
                                  ? _c(
                                      "div",
                                      { staticClass: "story-template" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "table-subtitle" },
                                          [
                                            _c("p", [
                                              _vm._v("Configurer son modèle"),
                                            ]),
                                          ]
                                        ),
                                        _c("div", { staticClass: "limit" }, [
                                          _c(
                                            "div",
                                            { staticClass: "limit-wrapper" },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      _vm.templateMode ===
                                                      "text_in_image",
                                                  },
                                                  attrs: {
                                                    "vs-value": "text_in_image",
                                                  },
                                                  model: {
                                                    value: _vm.templateMode,
                                                    callback: function ($$v) {
                                                      _vm.templateMode = $$v
                                                    },
                                                    expression: "templateMode",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.template.text_in_image"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      _vm.templateMode !=
                                                      "text_in_image",
                                                  },
                                                  attrs: {
                                                    "vs-value": "without",
                                                  },
                                                  model: {
                                                    value: _vm.templateMode,
                                                    callback: function ($$v) {
                                                      _vm.templateMode = $$v
                                                    },
                                                    expression: "templateMode",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.bots.template.without"
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "template-config" },
                                          [
                                            _vm.templateMode === "text_in_image"
                                              ? _c("component-template-maker", {
                                                  ref: "templateMaker",
                                                  attrs: {
                                                    configuration:
                                                      _vm.templateStory
                                                        .configuration,
                                                    typePost: "image",
                                                    feed:
                                                      _vm.bot.sources &&
                                                      _vm.bot.sources.length
                                                        ? _vm.bot.sources[0]
                                                        : null,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.bot.posts.mode === "story"
                                  ? _c(
                                      "div",
                                      { staticClass: "story-template" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "table-subtitle" },
                                          [
                                            _c("p", [
                                              _vm._v("Configurer son modèle"),
                                            ]),
                                          ]
                                        ),
                                        _c("div", { staticClass: "limit" }, [
                                          _c(
                                            "div",
                                            { staticClass: "limit-wrapper" },
                                            [
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      _vm.templateMode ===
                                                      "manual",
                                                  },
                                                  attrs: {
                                                    "vs-value": "manual",
                                                  },
                                                  model: {
                                                    value: _vm.templateMode,
                                                    callback: function ($$v) {
                                                      _vm.templateMode = $$v
                                                    },
                                                    expression: "templateMode",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        Personnalisé\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "vs-radio",
                                                {
                                                  class: {
                                                    active:
                                                      _vm.templateMode ==
                                                      "auto",
                                                  },
                                                  attrs: { "vs-value": "auto" },
                                                  model: {
                                                    value: _vm.templateMode,
                                                    callback: function ($$v) {
                                                      _vm.templateMode = $$v
                                                    },
                                                    expression: "templateMode",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        Prédéfini\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "template-config" },
                                          [
                                            _vm.templateMode === "manual"
                                              ? _c("component-template-maker", {
                                                  ref: "templateMaker",
                                                  attrs: {
                                                    configuration:
                                                      _vm.templateStory
                                                        .configuration,
                                                    feed:
                                                      _vm.bot.sources &&
                                                      _vm.bot.sources.length
                                                        ? _vm.bot.sources[0]
                                                        : null,
                                                  },
                                                })
                                              : _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "table-subtitle-template",
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          "Choisir un modèle : "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "template-preview-auto",
                                                    },
                                                    [
                                                      _vm.selectedPage.name ===
                                                      "nextplzofficiel"
                                                        ? _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "possible-template",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .templateStory
                                                                        .predefined,
                                                                    expression:
                                                                      "templateStory.predefined",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "radio",
                                                                  name: "templateChoice",
                                                                  value:
                                                                    "template_nextplz",
                                                                  checked: "",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      _vm
                                                                        .templateStory
                                                                        .predefined,
                                                                      "template_nextplz"
                                                                    ),
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        _vm.templateStory,
                                                                        "predefined",
                                                                        "template_nextplz"
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("img", {
                                                                attrs: {
                                                                  src: require("../../../assets/img/template_story_nextplz.png"),
                                                                  alt: "Template NextPLZ",
                                                                },
                                                              }),
                                                              _c(
                                                                "p",
                                                                {
                                                                  style: `top: 20%`,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                      " +
                                                                      _vm._s(
                                                                        _vm.bot
                                                                          .hashtagPrefix +
                                                                          " Texte de template " +
                                                                          _vm
                                                                            .bot
                                                                            .hashtag
                                                                      ) +
                                                                      "\n                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "possible-template",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm
                                                                        .templateStory
                                                                        .predefined,
                                                                    expression:
                                                                      "templateStory.predefined",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "radio",
                                                                  name: "templateChoice",
                                                                  value:
                                                                    "template1",
                                                                  checked: "",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    _vm._q(
                                                                      _vm
                                                                        .templateStory
                                                                        .predefined,
                                                                      "template1"
                                                                    ),
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$set(
                                                                        _vm.templateStory,
                                                                        "predefined",
                                                                        "template1"
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                              _c("img", {
                                                                attrs: {
                                                                  src: require("../../../assets/img/template_story_1.png"),
                                                                  alt: "Template 1",
                                                                },
                                                              }),
                                                              _c(
                                                                "p",
                                                                {
                                                                  style: `top: 20%`,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                      " +
                                                                      _vm._s(
                                                                        _vm.bot
                                                                          .hashtagPrefix +
                                                                          " Texte de template " +
                                                                          _vm
                                                                            .bot
                                                                            .hashtag
                                                                      ) +
                                                                      "\n                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "possible-template",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .templateStory
                                                                    .predefined,
                                                                expression:
                                                                  "templateStory.predefined",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "radio",
                                                              name: "templateChoice",
                                                              value:
                                                                "template2",
                                                              checked: "",
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm
                                                                  .templateStory
                                                                  .predefined,
                                                                "template2"
                                                              ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.templateStory,
                                                                  "predefined",
                                                                  "template2"
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c("img", {
                                                            attrs: {
                                                              src: require("../../../assets/img/template_story_2.jpg"),
                                                              alt: "Template 2",
                                                            },
                                                          }),
                                                          _c(
                                                            "p",
                                                            {
                                                              style: `top: 20%`,
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                      " +
                                                                  _vm._s(
                                                                    _vm.bot
                                                                      .hashtagPrefix +
                                                                      " Texte de template " +
                                                                      _vm.bot
                                                                        .hashtag
                                                                  ) +
                                                                  "\n                                    "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.bot.posts.mode === "story"
                                  ? _c(
                                      "div",
                                      { staticClass: "story-highlight" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Voulez vous mettre vos stories à la une ?"
                                          ),
                                        ]),
                                        _c(
                                          "vs-radio",
                                          {
                                            staticClass: "input-no",
                                            attrs: {
                                              "vs-name":
                                                "storyTemplateHighlight",
                                              "vs-value": null,
                                            },
                                            model: {
                                              value:
                                                _vm.templateStory.highlight,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.templateStory,
                                                  "highlight",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "templateStory.highlight",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Non, simplement ajouter la story"
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "highlights-wrapper" },
                                          [
                                            _vm._l(
                                              _vm.highlightsPage,
                                              function (item, idx) {
                                                return _c(
                                                  "label",
                                                  {
                                                    key: item.id,
                                                    staticClass: "highlight",
                                                    style:
                                                      _vm.templateStory
                                                        .highlight ===
                                                        item.id &&
                                                      "color: #B20564;",
                                                  },
                                                  [
                                                    _c("vs-radio", {
                                                      staticClass: "hidden",
                                                      attrs: {
                                                        "vs-name":
                                                          "storyTemplateHighlight",
                                                        "vs-value": item.id,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.templateStory
                                                            .highlight,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.templateStory,
                                                            "highlight",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "templateStory.highlight",
                                                      },
                                                    }),
                                                    _c("img", {
                                                      class:
                                                        _vm.templateStory
                                                          .highlight ===
                                                          item.id &&
                                                        "selected-highlight",
                                                      attrs: {
                                                        src: item.img,
                                                        alt: `highlight-${idx}`,
                                                      },
                                                    }),
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(item.title) +
                                                        "\n                              "
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "highlight",
                                                attrs: { for: "addHighlight" },
                                              },
                                              [
                                                _c("vs-radio", {
                                                  staticClass: "hidden",
                                                  attrs: {
                                                    id: "addHighlight",
                                                    "vs-name":
                                                      "storyTemplateHighlight",
                                                    "vs-value":
                                                      "__new_highlight__",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.templateStory
                                                        .highlight,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.templateStory,
                                                        "highlight",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "templateStory.highlight",
                                                  },
                                                }),
                                                _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "0.8rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Créer une nouvelle catégorie"
                                                    ),
                                                  ]
                                                ),
                                                _c("img", {
                                                  class:
                                                    _vm.templateStory
                                                      .highlight ===
                                                      "__new_highlight__" &&
                                                    "selected-highlight",
                                                  attrs: {
                                                    src: require("../../../assets/img/template_image.jpg"),
                                                    alt: `highlight-new`,
                                                  },
                                                }),
                                                _c("vs-input", {
                                                  attrs: {
                                                    danger:
                                                      !_vm.isValidHightlight,
                                                    "danger-text":
                                                      "Le nom n'est pas valide",
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      )
                                                        return null
                                                      $event.preventDefault()
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.newHighlight,
                                                    callback: function ($$v) {
                                                      _vm.newHighlight = $$v
                                                    },
                                                    expression: "newHighlight",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm.bot.posts.mode == "standard" &&
                          ["instagram"].includes(_vm.selectedPage.network) &&
                          _vm.linkedinConnected === "connected" &&
                          _vm.activeInstagramStories
                            ? _c(
                                "div",
                                { staticClass: "share-story" },
                                [
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "share-story-box",
                                      attrs: {
                                        checked:
                                          _vm.bot.afterAutoPost.story &&
                                          _vm.bot.afterAutoPost.story.shared,
                                      },
                                      on: { change: _vm.addSharedStory },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dash.bots.shared_story"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "vs-checkbox",
                                    {
                                      staticClass: "share-story-box",
                                      attrs: {
                                        checked:
                                          _vm.bot.afterAutoPost.story &&
                                          _vm.bot.afterAutoPost.story
                                            .share_to_facebook,
                                      },
                                      on: { change: _vm.addSharedStoryFB },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dash.bots.shared_story_fb")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.getBoardPagePinterest
                            ? _c("div", { staticClass: "table-subtitle" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.bots.post_content"))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          !_vm.getBoardPagePinterest
                            ? _c("p", { staticClass: "subtitle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dash.bots.post_content_subtitle")
                                  )
                                ),
                              ])
                            : _vm._e(),
                          !_vm.getBoardPagePinterest
                            ? _c("div", { staticClass: "post-content" }, [
                                _c("div", { staticClass: "display-wrapper" }, [
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.display,
                                          expression: "bot.posts.display",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "content",
                                        value: "title",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.bot.posts.display,
                                          "title"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "display",
                                            "title"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/text-title.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_text_title"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.display,
                                          expression: "bot.posts.display",
                                        },
                                      ],
                                      attrs: {
                                        type: "radio",
                                        name: "content",
                                        value: "description",
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.bot.posts.display,
                                          "description"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "display",
                                            "description"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/text-desc.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_text_desc"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm.bot.posts.mode == "standard"
                                    ? _c("div", { staticClass: "thumbnail" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.bot.posts.display,
                                              expression: "bot.posts.display",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "content",
                                            value: "none",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.bot.posts.display,
                                              "none"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.bot.posts,
                                                "display",
                                                "none"
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-wrapper" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thumbnail-content",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "vertical-align",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "thumbnail-img-wrapper",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: require("../../../assets/img/input/no-text.svg"),
                                                            alt: "txt",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "thumbnail-name",
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.bots.post_text_snippet"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.bot.posts.mode == "image" &&
                          [
                            "facebook",
                            "twitter",
                            "linkedin",
                            "bluesky",
                          ].includes(_vm.selectedPage.network)
                            ? _c("div", { staticClass: "table-subtitle" }, [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.$t("dash.bots.post_link"))),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.bot.posts.mode == "image" &&
                          [
                            "facebook",
                            "twitter",
                            "linkedin",
                            "bluesky",
                          ].includes(_vm.selectedPage.network)
                            ? _c("p", { staticClass: "subtitle" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dash.bots.post_link_subtitle"))
                                ),
                              ])
                            : _vm._e(),
                          _vm.bot.posts.mode == "image" &&
                          [
                            "facebook",
                            "twitter",
                            "linkedin",
                            "bluesky",
                          ].includes(_vm.selectedPage.network)
                            ? _c("div", { staticClass: "post-link" }, [
                                _c("div", { staticClass: "display-wrapper" }, [
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.positionlink,
                                          expression: "bot.posts.positionlink",
                                        },
                                      ],
                                      attrs: { type: "radio", name: "link" },
                                      domProps: {
                                        value: "in_posts",
                                        checked: _vm._q(
                                          _vm.bot.posts.positionlink,
                                          "in_posts"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "positionlink",
                                            "in_posts"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/instagram-post.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_link_in_posts"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.positionlink,
                                          expression: "bot.posts.positionlink",
                                        },
                                      ],
                                      attrs: { type: "radio", name: "link" },
                                      domProps: {
                                        value: "on_top_posts",
                                        checked: _vm._q(
                                          _vm.bot.posts.positionlink,
                                          "on_top_posts"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "positionlink",
                                            "on_top_posts"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/instagram-post.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_link_on_top_posts"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.positionlink,
                                          expression: "bot.posts.positionlink",
                                        },
                                      ],
                                      attrs: { type: "radio", name: "link" },
                                      domProps: {
                                        value: "in_comments",
                                        checked: _vm._q(
                                          _vm.bot.posts.positionlink,
                                          "in_comments"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "positionlink",
                                            "in_comments"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/text-desc.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_link_in_comments"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.positionlink,
                                          expression: "bot.posts.positionlink",
                                        },
                                      ],
                                      attrs: { type: "radio", name: "link" },
                                      domProps: {
                                        value: "in_posts_and_in_comments",
                                        checked: _vm._q(
                                          _vm.bot.posts.positionlink,
                                          "in_posts_and_in_comments"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "positionlink",
                                            "in_posts_and_in_comments"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/text-desc.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_link_in_posts_and_in_comments"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "thumbnail" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.bot.posts.positionlink,
                                          expression: "bot.posts.positionlink",
                                        },
                                      ],
                                      attrs: { type: "radio", name: "link" },
                                      domProps: {
                                        value: "on_top_posts_and_in_comments",
                                        checked: _vm._q(
                                          _vm.bot.posts.positionlink,
                                          "on_top_posts_and_in_comments"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.bot.posts,
                                            "positionlink",
                                            "on_top_posts_and_in_comments"
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "thumbnail-wrapper" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "thumbnail-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "vertical-align" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-img-wrapper",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("../../../assets/img/input/text-desc.svg"),
                                                        alt: "txt",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "thumbnail-name",
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.bots.post_link_on_top_posts_and_in_comments"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.selectedPage.network == "twitter"
                            ? _c("div", [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.post.twitter_options.reply_settings.title"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.post.twitter_options.reply_settings.subtitle"
                                      )
                                    )
                                  ),
                                ]),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.replySettings,
                                        expression: "replySettings",
                                      },
                                    ],
                                    staticClass: "selectboard",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.replySettings = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `dash.post.twitter_options.reply_settings.none`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "following" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `dash.post.twitter_options.reply_settings.following`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "mentionedUsers" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `dash.post.twitter_options.reply_settings.mentionedUsers`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "subscribers" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `dash.post.twitter_options.reply_settings.subscribers`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "option",
                                      { attrs: { value: "verified" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              `dash.post.twitter_options.reply_settings.verified`
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.getBoardPagePinterest
                            ? _c("div", [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.bots.board_title"))
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.bots.board_subtitle"))
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "title-item title-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-wrapper",
                                        staticStyle: { display: "flex" },
                                      },
                                      [
                                        _vm.boards && _vm.boards.board
                                          ? _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.boardSelected,
                                                    expression: "boardSelected",
                                                  },
                                                ],
                                                staticClass: "selectboard",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.boardSelected = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.boards.board.items,
                                                function (item, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      domProps: { value: item },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                          " +
                                                          _vm._s(item.name) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _c("vs-input", {
                                          staticClass: "newboard",
                                          attrs: { placeholder: "" },
                                          on: {
                                            keypress: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                            },
                                          },
                                          model: {
                                            value: _vm.newBoardName,
                                            callback: function ($$v) {
                                              _vm.newBoardName = $$v
                                            },
                                            expression: "newBoardName",
                                          },
                                        }),
                                        _c(
                                          "vs-button",
                                          {
                                            staticClass:
                                              "page-btn newboardbutton",
                                            attrs: {
                                              "vs-type": "filled",
                                              color: "#303030",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.newBoardofPinterest()
                                              },
                                            },
                                          },
                                          [_vm._v("créer")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "table-subtitle" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("dash.bots.post_frequency"))
                              ),
                            ]),
                          ]),
                          _c("p", { staticClass: "subtitle" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("dash.bots.post_frequency_subtitle")
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _c("div", { staticClass: "frequency" }, [
                            _c(
                              "div",
                              { staticClass: "defined" },
                              [
                                _vm.activeInstant
                                  ? _c(
                                      "div",
                                      { staticClass: "instant frequency-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "frequency-item" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.bot.frequency,
                                                  expression: "bot.frequency",
                                                },
                                              ],
                                              class: {
                                                disabled:
                                                  _vm.bot.sourceType ==
                                                    "none" ||
                                                  _vm.bot.posts
                                                    .display_instagram ===
                                                    "story",
                                              },
                                              attrs: {
                                                type: "radio",
                                                name: "frequency",
                                                disabled:
                                                  _vm.bot.sourceType ==
                                                    "none" ||
                                                  _vm.bot.posts
                                                    .display_instagram ===
                                                    "story",
                                                "data-qa":
                                                  "form-bot-frequency-instant",
                                              },
                                              domProps: {
                                                value: {
                                                  custom: false,
                                                  value: "instant",
                                                },
                                                checked: _vm._q(
                                                  _vm.bot.frequency,
                                                  {
                                                    custom: false,
                                                    value: "instant",
                                                  }
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$set(
                                                    _vm.bot,
                                                    "frequency",
                                                    {
                                                      custom: false,
                                                      value: "instant",
                                                    }
                                                  )
                                                },
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "frequency-wrapper",
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.bots.post_instant"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("img", {
                                                  staticClass: "white",
                                                  attrs: {
                                                    src: require("../../../assets/img/tabs/Bots-icon-white.svg"),
                                                    alt: "bot",
                                                  },
                                                }),
                                                _c("img", {
                                                  staticClass: "pink",
                                                  attrs: {
                                                    src: require("../../../assets/img/tabs/Bots-icon.svg"),
                                                    alt: "bot",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._l(_vm.possibleFrequencies, function (f) {
                                  return _c(
                                    "div",
                                    { key: f, staticClass: "frequency-item" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.bot.frequency,
                                            expression: "bot.frequency",
                                          },
                                        ],
                                        class: {
                                          disabled:
                                            _vm.bot.sourceType == "none" ||
                                            _vm.bot.posts.display_instagram ===
                                              "story",
                                        },
                                        attrs: {
                                          type: "radio",
                                          name: "frequency",
                                          disabled:
                                            _vm.bot.sourceType == "none" ||
                                            _vm.bot.posts.display_instagram ===
                                              "story",
                                          "data-qa": `form-bot-frequency-${f}`,
                                        },
                                        domProps: {
                                          value: { value: f, custom: false },
                                          checked: _vm._q(_vm.bot.frequency, {
                                            value: f,
                                            custom: false,
                                          }),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.bot,
                                              "frequency",
                                              { value: f, custom: false }
                                            )
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "frequency-wrapper" },
                                        [
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.humanizeTime(f)
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                _vm.bot.sourceType != "none"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "frequency-item custom-frequency",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.bot.frequency.custom,
                                              expression:
                                                "bot.frequency.custom",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            name: "frequency",
                                            id: "custom-frequency-radio",
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              _vm.bot.frequency.custom,
                                              true
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.frequencyInputElt.select()
                                            },
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.bot.frequency,
                                                "custom",
                                                true
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "frequency-wrapper" },
                                          [
                                            _c("vs-input-number", {
                                              attrs: {
                                                id: "custom-frequency-nbr",
                                                color: "dark",
                                                size: "mini",
                                                step: 5,
                                                placeholder: _vm.$t(
                                                  "dash.bots.post_frequency_other"
                                                ),
                                              },
                                              on: {
                                                keypress: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                },
                                                focus: function ($event) {
                                                  _vm.bot.frequency.custom = true
                                                },
                                                change: function ($event) {
                                                  _vm.bot.frequency.value =
                                                    _vm.bot.frequency.value %
                                                      _vm.minimumFrequency ==
                                                    0
                                                      ? _vm.bot.frequency.value
                                                      : parseInt(
                                                          _vm.bot.frequency
                                                            .value
                                                        ) +
                                                        parseInt(
                                                          _vm.minimumFrequency
                                                        ) -
                                                        (_vm.bot.frequency
                                                          .value %
                                                          _vm.minimumFrequency)
                                                  /*bot.frequency.value < minimumFrequency
                                                      ? minimumFrequency
                                                      : bot.frequency.value*/
                                                },
                                                blur: function ($event) {
                                                  _vm.bot.frequency.value =
                                                    _vm.bot.frequency.value %
                                                      _vm.minimumFrequency ==
                                                    0
                                                      ? _vm.bot.frequency.value
                                                      : _vm.bot.frequency
                                                          .value +
                                                        _vm.minimumFrequency -
                                                        (_vm.bot.frequency
                                                          .value %
                                                          _vm.minimumFrequency)
                                                  /*bot.frequency.value < minimumFrequency
                                                      ? minimumFrequency
                                                      : bot.frequency.value*/
                                                },
                                              },
                                              model: {
                                                value: _vm.bot.frequency.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.bot.frequency,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "bot.frequency.value",
                                              },
                                            }),
                                            _c("p", [_vm._v("(min)")]),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "manual" }, [
                              _c("div", { staticClass: "frequency-item" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.bot.frequency,
                                      expression: "bot.frequency",
                                    },
                                  ],
                                  attrs: {
                                    type: "radio",
                                    name: "frequency",
                                    "data-qa": "form-bot-frequency-manual",
                                  },
                                  domProps: {
                                    value: { custom: false, value: 0 },
                                    checked: _vm._q(_vm.bot.frequency, {
                                      custom: false,
                                      value: 0,
                                    }),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.$set(_vm.bot, "frequency", {
                                        custom: false,
                                        value: 0,
                                      })
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "frequency-wrapper" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.post_frequency_manual"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          !_vm.checkLock("partner")
                            ? _c("div", { staticClass: "limit" }, [
                                _c("div", { staticClass: "table-subtitle" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("dash.bots.post_limit"))
                                    ),
                                  ]),
                                ]),
                                _c("p", { staticClass: "subtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.bots.post_limit_subtitle")
                                    )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "limit-wrapper" },
                                  [
                                    _c(
                                      "vs-radio",
                                      {
                                        class: {
                                          active: _vm.showLimit == "false",
                                        },
                                        style: {
                                          filter:
                                            !_vm.checkLock("bots_daily") &&
                                            !_vm.checkLock("partner")
                                              ? "grayscale(1)"
                                              : "",
                                        },
                                        attrs: {
                                          "vs-value": "false",
                                          disabled:
                                            !_vm.checkLock("bots_daily") &&
                                            !_vm.checkLock("partner"),
                                        },
                                        model: {
                                          value: _vm.showLimit,
                                          callback: function ($$v) {
                                            _vm.showLimit = $$v
                                          },
                                          expression: "showLimit",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.post_limit_nolimit"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "vs-radio",
                                      {
                                        class: {
                                          active: _vm.showLimit == "true",
                                        },
                                        attrs: { "vs-value": "true" },
                                        model: {
                                          value: _vm.showLimit,
                                          callback: function ($$v) {
                                            _vm.showLimit = $$v
                                          },
                                          expression: "showLimit",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.post_limit_yeslimit"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text:
                                            _vm.checkLock("posts_limit") !==
                                            Infinity
                                              ? _vm.checkLock("posts_limit") +
                                                " " +
                                                this.$t(
                                                  "dash.settings.plans.details.post_limit_per_day"
                                                ) +
                                                " max"
                                              : "",
                                          position: "right",
                                        },
                                      },
                                      [
                                        _vm.showLimit == "true"
                                          ? _c("vs-input-number", {
                                              attrs: {
                                                color: "dark",
                                                size: "mini",
                                                placeholder: "0",
                                                max: _vm.checkLock(
                                                  "posts_limit"
                                                ),
                                                min: 1,
                                              },
                                              on: {
                                                keypress: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                },
                                              },
                                              model: {
                                                value: _vm.bot.limit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.bot,
                                                    "limit",
                                                    $$v
                                                  )
                                                },
                                                expression: "bot.limit",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "table-subtitle" }, [
                            _c("p", [_vm._v("Planning")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "planning" },
                            [
                              _c("component-planning", {
                                attrs: { week: _vm.bot.planning },
                                on: { change: _vm.updatePlanning },
                              }),
                            ],
                            1
                          ),
                          ["facebook", "twitter", "linkedin"].includes(
                            _vm.selectedPage.network
                          )
                            ? _c("div", { staticClass: "table-subtitle" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "dash.bots.after-auto-post_subtitle"
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          ["facebook", "twitter", "linkedin"].includes(
                            _vm.selectedPage.network
                          )
                            ? _c("div", { staticClass: "after-auto-post" }, [
                                _vm.selectedPage.network == "twitter"
                                  ? _c("div", { staticClass: "retweet-auto" }, [
                                      _c("p", { staticClass: "subtitle" }, [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.retweetAuto_subtitle"
                                              )
                                            ) +
                                            "\n                              "
                                        ),
                                        _vm.bot.afterAutoPost &&
                                        _vm.bot.afterAutoPost.retweetAuto &&
                                        _vm.bot.afterAutoPost.retweetAuto
                                          .length > 0 &&
                                        _vm.bot.afterAutoPost.retweetAuto.filter(
                                          (r) => r.active
                                        ).length > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.bot.afterAutoPost.retweetAuto.filter(
                                                      (r) => r.active
                                                    ).length
                                                  ) +
                                                  " retweet)"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _c("div", { staticClass: "content" }, [
                                        _c(
                                          "ul",
                                          [
                                            _vm._l(
                                              _vm.bot.afterAutoPost.retweetAuto,
                                              function (retweetAuto, key) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: `used-${key}`,
                                                    staticClass: "row",
                                                  },
                                                  [
                                                    _vm.getPage(
                                                      retweetAuto.page
                                                    )
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-wrapper",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "vs-switch",
                                                                        {
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .bot
                                                                                  .afterAutoPost
                                                                                  .retweetAuto[
                                                                                  key
                                                                                ]
                                                                                  .active,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .bot
                                                                                      .afterAutoPost
                                                                                      .retweetAuto[
                                                                                      key
                                                                                    ],
                                                                                    "active",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "bot.afterAutoPost.retweetAuto[key].active",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "vertical-align",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "page-image-avatar",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  page: _vm.getPage(
                                                                                    retweetAuto.page
                                                                                  ),
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "page-name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.getPage(
                                                                                    retweetAuto.page
                                                                                  )
                                                                                    .name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                              retweetAuto.active
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "frequency",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "defined",
                                                                        },
                                                                        [
                                                                          _vm._l(
                                                                            _vm.possibleFrequencies,
                                                                            function (
                                                                              f
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key: f,
                                                                                  staticClass:
                                                                                    "frequency-item",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "input",
                                                                                    {
                                                                                      directives:
                                                                                        [
                                                                                          {
                                                                                            name: "model",
                                                                                            rawName:
                                                                                              "v-model",
                                                                                            value:
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency,
                                                                                            expression:
                                                                                              "bot.afterAutoPost.retweetAuto[key].frequency",
                                                                                          },
                                                                                        ],
                                                                                      class:
                                                                                        {
                                                                                          disabled:
                                                                                            _vm
                                                                                              .bot
                                                                                              .sourceType ==
                                                                                              "none" ||
                                                                                            _vm
                                                                                              .bot
                                                                                              .posts
                                                                                              .mode ===
                                                                                              "story",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          type: "radio",
                                                                                          name: `retweet-frequency-${key}`,
                                                                                          disabled:
                                                                                            _vm
                                                                                              .bot
                                                                                              .sourceType ==
                                                                                              "none" ||
                                                                                            _vm
                                                                                              .bot
                                                                                              .posts
                                                                                              .mode ===
                                                                                              "story",
                                                                                        },
                                                                                      domProps:
                                                                                        {
                                                                                          value:
                                                                                            {
                                                                                              value:
                                                                                                f,
                                                                                              custom: false,
                                                                                            },
                                                                                          checked:
                                                                                            _vm._q(
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency,
                                                                                              {
                                                                                                value:
                                                                                                  f,
                                                                                                custom: false,
                                                                                              }
                                                                                            ),
                                                                                        },
                                                                                      on: {
                                                                                        change:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.$set(
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ],
                                                                                              "frequency",
                                                                                              {
                                                                                                value:
                                                                                                  f,
                                                                                                custom: false,
                                                                                              }
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "frequency-wrapper",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          domProps:
                                                                                            {
                                                                                              innerHTML:
                                                                                                _vm._s(
                                                                                                  _vm.humanizeTime(
                                                                                                    f
                                                                                                  )
                                                                                                ),
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          _vm
                                                                            .bot
                                                                            .sourceType !=
                                                                            "none" &&
                                                                          _vm
                                                                            .bot
                                                                            .posts
                                                                            .mode !==
                                                                            "story"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "frequency-item custom-frequency",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "input",
                                                                                    {
                                                                                      directives:
                                                                                        [
                                                                                          {
                                                                                            name: "model",
                                                                                            rawName:
                                                                                              "v-model",
                                                                                            value:
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency
                                                                                                .custom,
                                                                                            expression:
                                                                                              "bot.afterAutoPost.retweetAuto[key].frequency.custom",
                                                                                          },
                                                                                        ],
                                                                                      attrs:
                                                                                        {
                                                                                          type: "radio",
                                                                                          name: "frequency",
                                                                                          id: "custom-frequency-radio",
                                                                                        },
                                                                                      domProps:
                                                                                        {
                                                                                          value: true,
                                                                                          checked:
                                                                                            _vm._q(
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency
                                                                                                .custom,
                                                                                              true
                                                                                            ),
                                                                                        },
                                                                                      on: {
                                                                                        click:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.document
                                                                                              .querySelector(
                                                                                                `#custom-retweet-frequency-nbr-${key}`
                                                                                              )
                                                                                              .select()
                                                                                          },
                                                                                        change:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.$set(
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .retweetAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency,
                                                                                              "custom",
                                                                                              true
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "frequency-wrapper",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "vs-input-number",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              id: `custom-retweet-frequency-nbr-${key}`,
                                                                                              color:
                                                                                                "dark",
                                                                                              size: "mini",
                                                                                              step: 5,
                                                                                              placeholder:
                                                                                                _vm.$t(
                                                                                                  "dash.bots.post_frequency_other"
                                                                                                ),
                                                                                            },
                                                                                          on: {
                                                                                            keypress:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                if (
                                                                                                  !$event.type.indexOf(
                                                                                                    "key"
                                                                                                  ) &&
                                                                                                  _vm._k(
                                                                                                    $event.keyCode,
                                                                                                    "enter",
                                                                                                    13,
                                                                                                    $event.key,
                                                                                                    "Enter"
                                                                                                  )
                                                                                                )
                                                                                                  return null
                                                                                                $event.preventDefault()
                                                                                              },
                                                                                            focus:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.bot.afterAutoPost.retweetAuto[
                                                                                                  key
                                                                                                ].frequency.custom = true
                                                                                              },
                                                                                            change:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.bot.afterAutoPost.retweetAuto[
                                                                                                  key
                                                                                                ].frequency.value =
                                                                                                  _vm
                                                                                                    .bot
                                                                                                    .afterAutoPost
                                                                                                    .retweetAuto[
                                                                                                    key
                                                                                                  ]
                                                                                                    .frequency
                                                                                                    .value %
                                                                                                    _vm.minimumFrequency ==
                                                                                                  0
                                                                                                    ? _vm
                                                                                                        .bot
                                                                                                        .afterAutoPost
                                                                                                        .retweetAuto[
                                                                                                        key
                                                                                                      ]
                                                                                                        .frequency
                                                                                                        .value
                                                                                                    : parseInt(
                                                                                                        _vm
                                                                                                          .bot
                                                                                                          .afterAutoPost
                                                                                                          .retweetAuto[
                                                                                                          key
                                                                                                        ]
                                                                                                          .frequency
                                                                                                          .value
                                                                                                      ) +
                                                                                                      parseInt(
                                                                                                        _vm.minimumFrequency
                                                                                                      ) -
                                                                                                      (_vm
                                                                                                        .bot
                                                                                                        .afterAutoPost
                                                                                                        .retweetAuto[
                                                                                                        key
                                                                                                      ]
                                                                                                        .frequency
                                                                                                        .value %
                                                                                                        _vm.minimumFrequency)
                                                                                              },
                                                                                            blur: function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.bot.afterAutoPost.retweetAuto[
                                                                                                key
                                                                                              ].frequency.value =
                                                                                                _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .retweetAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value %
                                                                                                  _vm.minimumFrequency ==
                                                                                                0
                                                                                                  ? _vm
                                                                                                      .bot
                                                                                                      .afterAutoPost
                                                                                                      .retweetAuto[
                                                                                                      key
                                                                                                    ]
                                                                                                      .frequency
                                                                                                      .value
                                                                                                  : _vm
                                                                                                      .bot
                                                                                                      .afterAutoPost
                                                                                                      .retweetAuto[
                                                                                                      key
                                                                                                    ]
                                                                                                      .frequency
                                                                                                      .value +
                                                                                                    _vm.minimumFrequency -
                                                                                                    (_vm
                                                                                                      .bot
                                                                                                      .afterAutoPost
                                                                                                      .retweetAuto[
                                                                                                      key
                                                                                                    ]
                                                                                                      .frequency
                                                                                                      .value %
                                                                                                      _vm.minimumFrequency)
                                                                                            },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .retweetAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .bot
                                                                                                      .afterAutoPost
                                                                                                      .retweetAuto[
                                                                                                      key
                                                                                                    ]
                                                                                                      .frequency,
                                                                                                    "value",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "bot.afterAutoPost.retweetAuto[key].frequency.value",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "p",
                                                                                        [
                                                                                          _vm._v(
                                                                                            " (min)"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        2
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._l(
                                              _vm.getSameNetworkPagesWithBot.filter(
                                                (p) =>
                                                  !_vm.bot.afterAutoPost.retweetAuto.find(
                                                    (r) => r.page == p.id
                                                  )
                                              ),
                                              function (item, key) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: `unused-${key}`,
                                                    staticClass: "row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "page" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-content",
                                                              },
                                                              [
                                                                _c(
                                                                  "vs-switch",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.addAfterAutoPost(
                                                                            "retweet",
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vertical-align",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "page-image-avatar",
                                                                      {
                                                                        attrs: {
                                                                          page: item,
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "page-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.selectedPage.network == "facebook"
                                  ? _c("div", { staticClass: "reshare-auto" }, [
                                      _c("p", { staticClass: "subtitle" }, [
                                        _vm._v(
                                          "\n                              " +
                                            _vm._s(
                                              _vm.$t(
                                                "dash.bots.reshareAuto_subtitle"
                                              )
                                            ) +
                                            "\n                              "
                                        ),
                                        _vm.bot.afterAutoPost &&
                                        _vm.bot.afterAutoPost.reshareAuto &&
                                        _vm.bot.afterAutoPost.reshareAuto
                                          .length > 0 &&
                                        _vm.bot.afterAutoPost.reshareAuto.filter(
                                          (r) => r.active
                                        ).length > 0
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    _vm.bot.afterAutoPost.reshareAuto.filter(
                                                      (r) => r.active
                                                    ).length
                                                  ) +
                                                  " reshare)"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _c("div", { staticClass: "content" }, [
                                        _c(
                                          "ul",
                                          [
                                            _vm._l(
                                              _vm.bot.afterAutoPost.reshareAuto,
                                              function (reshareAuto, key) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: `used-${key}`,
                                                    staticClass: "row",
                                                  },
                                                  [
                                                    _vm.getPage(
                                                      reshareAuto.page
                                                    )
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-wrapper",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "page-content",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "vs-switch",
                                                                        {
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .bot
                                                                                  .afterAutoPost
                                                                                  .reshareAuto[
                                                                                  key
                                                                                ]
                                                                                  .active,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm
                                                                                      .bot
                                                                                      .afterAutoPost
                                                                                      .reshareAuto[
                                                                                      key
                                                                                    ],
                                                                                    "active",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "bot.afterAutoPost.reshareAuto[key].active",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "vertical-align",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "page-image-avatar",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  page: _vm.getPage(
                                                                                    reshareAuto.page
                                                                                  ),
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "page-name",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.getPage(
                                                                                    reshareAuto.page
                                                                                  )
                                                                                    .name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          reshareAuto.active
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "frequency",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "defined",
                                                                    },
                                                                    [
                                                                      _vm._l(
                                                                        _vm.possibleFrequencies,
                                                                        function (
                                                                          f
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key: f,
                                                                              staticClass:
                                                                                "frequency-item",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "model",
                                                                                        rawName:
                                                                                          "v-model",
                                                                                        value:
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency,
                                                                                        expression:
                                                                                          "bot.afterAutoPost.reshareAuto[key].frequency",
                                                                                      },
                                                                                    ],
                                                                                  class:
                                                                                    {
                                                                                      disabled:
                                                                                        _vm
                                                                                          .bot
                                                                                          .sourceType ==
                                                                                          "none" ||
                                                                                        _vm
                                                                                          .bot
                                                                                          .posts
                                                                                          .mode ===
                                                                                          "story",
                                                                                    },
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                      name: `reshare-frequency-${key}`,
                                                                                      disabled:
                                                                                        _vm
                                                                                          .bot
                                                                                          .sourceType ==
                                                                                          "none" ||
                                                                                        _vm
                                                                                          .bot
                                                                                          .posts
                                                                                          .mode ===
                                                                                          "story",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      value:
                                                                                        {
                                                                                          value:
                                                                                            f,
                                                                                          custom: false,
                                                                                        },
                                                                                      checked:
                                                                                        _vm._q(
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency,
                                                                                          {
                                                                                            value:
                                                                                              f,
                                                                                            custom: false,
                                                                                          }
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.$set(
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ],
                                                                                          "frequency",
                                                                                          {
                                                                                            value:
                                                                                              f,
                                                                                            custom: false,
                                                                                          }
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "frequency-wrapper",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      domProps:
                                                                                        {
                                                                                          innerHTML:
                                                                                            _vm._s(
                                                                                              _vm.humanizeTime(
                                                                                                f
                                                                                              )
                                                                                            ),
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      _vm.bot
                                                                        .sourceType !=
                                                                        "none" &&
                                                                      _vm.bot
                                                                        .posts
                                                                        .mode !==
                                                                        "story"
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "frequency-item custom-frequency",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "model",
                                                                                        rawName:
                                                                                          "v-model",
                                                                                        value:
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency
                                                                                            .custom,
                                                                                        expression:
                                                                                          "bot.afterAutoPost.reshareAuto[key].frequency.custom",
                                                                                      },
                                                                                    ],
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                      name: "frequency",
                                                                                      id: "custom-frequency-radio",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      value: true,
                                                                                      checked:
                                                                                        _vm._q(
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency
                                                                                            .custom,
                                                                                          true
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.document
                                                                                          .querySelector(
                                                                                            `#custom-reshare-frequency-nbr-${key}`
                                                                                          )
                                                                                          .select()
                                                                                      },
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.$set(
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .reshareAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency,
                                                                                          "custom",
                                                                                          true
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "frequency-wrapper",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "vs-input-number",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          id: `custom-reshare-frequency-nbr-${key}`,
                                                                                          color:
                                                                                            "dark",
                                                                                          size: "mini",
                                                                                          step: 5,
                                                                                          placeholder:
                                                                                            _vm.$t(
                                                                                              "dash.bots.post_frequency_other"
                                                                                            ),
                                                                                        },
                                                                                      on: {
                                                                                        keypress:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            if (
                                                                                              !$event.type.indexOf(
                                                                                                "key"
                                                                                              ) &&
                                                                                              _vm._k(
                                                                                                $event.keyCode,
                                                                                                "enter",
                                                                                                13,
                                                                                                $event.key,
                                                                                                "Enter"
                                                                                              )
                                                                                            )
                                                                                              return null
                                                                                            $event.preventDefault()
                                                                                          },
                                                                                        focus:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.bot.afterAutoPost.reshareAuto[
                                                                                              key
                                                                                            ].frequency.custom = true
                                                                                          },
                                                                                        change:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            _vm.bot.afterAutoPost.reshareAuto[
                                                                                              key
                                                                                            ].frequency.value =
                                                                                              _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .reshareAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency
                                                                                                .value %
                                                                                                _vm.minimumFrequency ==
                                                                                              0
                                                                                                ? _vm
                                                                                                    .bot
                                                                                                    .afterAutoPost
                                                                                                    .reshareAuto[
                                                                                                    key
                                                                                                  ]
                                                                                                    .frequency
                                                                                                    .value
                                                                                                : parseInt(
                                                                                                    _vm
                                                                                                      .bot
                                                                                                      .afterAutoPost
                                                                                                      .reshareAuto[
                                                                                                      key
                                                                                                    ]
                                                                                                      .frequency
                                                                                                      .value
                                                                                                  ) +
                                                                                                  parseInt(
                                                                                                    _vm.minimumFrequency
                                                                                                  ) -
                                                                                                  (_vm
                                                                                                    .bot
                                                                                                    .afterAutoPost
                                                                                                    .reshareAuto[
                                                                                                    key
                                                                                                  ]
                                                                                                    .frequency
                                                                                                    .value %
                                                                                                    _vm.minimumFrequency)
                                                                                          },
                                                                                        blur: function (
                                                                                          $event
                                                                                        ) {
                                                                                          _vm.bot.afterAutoPost.reshareAuto[
                                                                                            key
                                                                                          ].frequency.value =
                                                                                            _vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .reshareAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency
                                                                                              .value %
                                                                                              _vm.minimumFrequency ==
                                                                                            0
                                                                                              ? _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .reshareAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value
                                                                                              : _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .reshareAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value +
                                                                                                _vm.minimumFrequency -
                                                                                                (_vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .reshareAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value %
                                                                                                  _vm.minimumFrequency)
                                                                                        },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .reshareAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency
                                                                                              .value,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .reshareAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency,
                                                                                                "value",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "bot.afterAutoPost.reshareAuto[key].frequency.value",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    [
                                                                                      _vm._v(
                                                                                        " (min)"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    2
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._l(
                                              _vm.getSameNetworkPagesWithBot.filter(
                                                (p) =>
                                                  !_vm.bot.afterAutoPost.reshareAuto.find(
                                                    (r) => r.page == p.id
                                                  )
                                              ),
                                              function (item, key) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: `unused-${key}`,
                                                    staticClass: "row",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "page" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "page-content",
                                                              },
                                                              [
                                                                _c(
                                                                  "vs-switch",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.addAfterAutoPost(
                                                                            "reshare",
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vertical-align",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "page-image-avatar",
                                                                      {
                                                                        attrs: {
                                                                          page: item,
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "page-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.name
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "repost-auto" }, [
                                  _c("p", { staticClass: "subtitle" }, [
                                    _vm._v(
                                      "\n                              " +
                                        _vm._s(
                                          _vm.$t(
                                            "dash.bots.repostAuto_subtitle"
                                          )
                                        ) +
                                        "\n                              "
                                    ),
                                    _vm.bot.afterAutoPost &&
                                    _vm.bot.afterAutoPost.repostAuto &&
                                    _vm.bot.afterAutoPost.repostAuto.length >
                                      0 &&
                                    _vm.bot.afterAutoPost.repostAuto.filter(
                                      (r) => r.active
                                    ).length > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.bot.afterAutoPost.repostAuto.filter(
                                                  (r) => r.active
                                                ).length
                                              ) +
                                              " repost)"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _c("div", { staticClass: "content" }, [
                                    _c(
                                      "ul",
                                      [
                                        _vm._l(
                                          _vm.bot.afterAutoPost.repostAuto,
                                          function (repostAuto, key) {
                                            return _c(
                                              "li",
                                              {
                                                key: `used-${key}`,
                                                staticClass: "row",
                                              },
                                              [
                                                _vm.getPage(repostAuto.page)
                                                  ? _c("div", [
                                                      _c(
                                                        "div",
                                                        { staticClass: "page" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page-wrapper",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-content",
                                                                },
                                                                [
                                                                  _c(
                                                                    "vs-switch",
                                                                    {
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .bot
                                                                            .afterAutoPost
                                                                            .repostAuto[
                                                                            key
                                                                          ]
                                                                            .active,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .bot
                                                                                .afterAutoPost
                                                                                .repostAuto[
                                                                                key
                                                                              ],
                                                                              "active",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "bot.afterAutoPost.repostAuto[key].active",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "vertical-align",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "page-image-avatar",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              page: _vm.getPage(
                                                                                repostAuto.page
                                                                              ),
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "page-name",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.getPage(
                                                                                repostAuto.page
                                                                              )
                                                                                .name
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      repostAuto.active
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "frequency",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "defined",
                                                                },
                                                                [
                                                                  _vm._l(
                                                                    _vm.possibleFrequencies,
                                                                    function (
                                                                      f
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: f,
                                                                          staticClass:
                                                                            "frequency-item",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ]
                                                                                        .frequency,
                                                                                    expression:
                                                                                      "bot.afterAutoPost.repostAuto[key].frequency",
                                                                                  },
                                                                                ],
                                                                              class:
                                                                                {
                                                                                  disabled:
                                                                                    _vm
                                                                                      .bot
                                                                                      .sourceType ==
                                                                                      "none" ||
                                                                                    _vm
                                                                                      .bot
                                                                                      .posts
                                                                                      .mode ===
                                                                                      "story",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  type: "radio",
                                                                                  name: `repost-frequency-${key}`,
                                                                                  disabled:
                                                                                    _vm
                                                                                      .bot
                                                                                      .sourceType ==
                                                                                      "none" ||
                                                                                    _vm
                                                                                      .bot
                                                                                      .posts
                                                                                      .mode ===
                                                                                      "story",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    {
                                                                                      value:
                                                                                        f,
                                                                                      custom: false,
                                                                                    },
                                                                                  checked:
                                                                                    _vm._q(
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ]
                                                                                        .frequency,
                                                                                      {
                                                                                        value:
                                                                                          f,
                                                                                        custom: false,
                                                                                      }
                                                                                    ),
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$set(
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ],
                                                                                      "frequency",
                                                                                      {
                                                                                        value:
                                                                                          f,
                                                                                        custom: false,
                                                                                      }
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "frequency-wrapper",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  domProps:
                                                                                    {
                                                                                      innerHTML:
                                                                                        _vm._s(
                                                                                          _vm.humanizeTime(
                                                                                            f
                                                                                          )
                                                                                        ),
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  _vm.bot
                                                                    .sourceType !=
                                                                    "none" &&
                                                                  _vm.bot.posts
                                                                    .mode !==
                                                                    "story"
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "frequency-item custom-frequency",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "input",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ]
                                                                                        .frequency
                                                                                        .custom,
                                                                                    expression:
                                                                                      "bot.afterAutoPost.repostAuto[key].frequency.custom",
                                                                                  },
                                                                                ],
                                                                              attrs:
                                                                                {
                                                                                  type: "radio",
                                                                                  name: "frequency",
                                                                                  id: "custom-frequency-radio",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  value: true,
                                                                                  checked:
                                                                                    _vm._q(
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ]
                                                                                        .frequency
                                                                                        .custom,
                                                                                      true
                                                                                    ),
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.document
                                                                                      .querySelector(
                                                                                        `#custom-repost-frequency-nbr-${key}`
                                                                                      )
                                                                                      .select()
                                                                                  },
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.$set(
                                                                                      _vm
                                                                                        .bot
                                                                                        .afterAutoPost
                                                                                        .repostAuto[
                                                                                        key
                                                                                      ]
                                                                                        .frequency,
                                                                                      "custom",
                                                                                      true
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "frequency-wrapper",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "vs-input-number",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id: `custom-repost-frequency-nbr-${key}`,
                                                                                      color:
                                                                                        "dark",
                                                                                      size: "mini",
                                                                                      step: 5,
                                                                                      placeholder:
                                                                                        _vm.$t(
                                                                                          "dash.bots.post_frequency_other"
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    keypress:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        if (
                                                                                          !$event.type.indexOf(
                                                                                            "key"
                                                                                          ) &&
                                                                                          _vm._k(
                                                                                            $event.keyCode,
                                                                                            "enter",
                                                                                            13,
                                                                                            $event.key,
                                                                                            "Enter"
                                                                                          )
                                                                                        )
                                                                                          return null
                                                                                        $event.preventDefault()
                                                                                      },
                                                                                    focus:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.bot.afterAutoPost.repostAuto[
                                                                                          key
                                                                                        ].frequency.custom = true
                                                                                      },
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.bot.afterAutoPost.repostAuto[
                                                                                          key
                                                                                        ].frequency.value =
                                                                                          _vm
                                                                                            .bot
                                                                                            .afterAutoPost
                                                                                            .repostAuto[
                                                                                            key
                                                                                          ]
                                                                                            .frequency
                                                                                            .value %
                                                                                            _vm.minimumFrequency ==
                                                                                          0
                                                                                            ? _vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .repostAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency
                                                                                                .value
                                                                                            : parseInt(
                                                                                                _vm
                                                                                                  .bot
                                                                                                  .afterAutoPost
                                                                                                  .repostAuto[
                                                                                                  key
                                                                                                ]
                                                                                                  .frequency
                                                                                                  .value
                                                                                              ) +
                                                                                              parseInt(
                                                                                                _vm.minimumFrequency
                                                                                              ) -
                                                                                              (_vm
                                                                                                .bot
                                                                                                .afterAutoPost
                                                                                                .repostAuto[
                                                                                                key
                                                                                              ]
                                                                                                .frequency
                                                                                                .value %
                                                                                                _vm.minimumFrequency)
                                                                                      },
                                                                                    blur: function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.bot.afterAutoPost.repostAuto[
                                                                                        key
                                                                                      ].frequency.value =
                                                                                        _vm
                                                                                          .bot
                                                                                          .afterAutoPost
                                                                                          .repostAuto[
                                                                                          key
                                                                                        ]
                                                                                          .frequency
                                                                                          .value %
                                                                                          _vm.minimumFrequency ==
                                                                                        0
                                                                                          ? _vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .repostAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency
                                                                                              .value
                                                                                          : _vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .repostAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency
                                                                                              .value +
                                                                                            _vm.minimumFrequency -
                                                                                            (_vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .repostAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency
                                                                                              .value %
                                                                                              _vm.minimumFrequency)
                                                                                    },
                                                                                  },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .bot
                                                                                          .afterAutoPost
                                                                                          .repostAuto[
                                                                                          key
                                                                                        ]
                                                                                          .frequency
                                                                                          .value,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .bot
                                                                                              .afterAutoPost
                                                                                              .repostAuto[
                                                                                              key
                                                                                            ]
                                                                                              .frequency,
                                                                                            "value",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "bot.afterAutoPost.repostAuto[key].frequency.value",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "p",
                                                                                [
                                                                                  _vm._v(
                                                                                    " (min)"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._l(
                                          _vm.getAllPagesWithBot.filter(
                                            (p) =>
                                              !_vm.bot.afterAutoPost.repostAuto.find(
                                                (r) => r.page == p.id
                                              )
                                          ),
                                          function (item, key) {
                                            return _c(
                                              "li",
                                              {
                                                key: `unused-${key}`,
                                                staticClass: "row",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "page" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-wrapper",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "page-content",
                                                          },
                                                          [
                                                            _c("vs-switch", {
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.addAfterAutoPost(
                                                                      "repost",
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "vertical-align",
                                                              },
                                                              [
                                                                _c(
                                                                  "page-image-avatar",
                                                                  {
                                                                    attrs: {
                                                                      page: item,
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "page-name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("bot.title"),
                                expression: "errors.has('bot.title')",
                              },
                            ],
                            staticClass: "warning-lbl fa fa-warning",
                          }),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("bot.title"),
                                  expression: "errors.has('bot.title')",
                                },
                              ],
                              staticClass: "help is-danger",
                            },
                            [_vm._v(_vm._s(_vm.errors.first("bot.title")))]
                          ),
                          _c(
                            "div",
                            { staticClass: "buttons-wrapper" },
                            [
                              _c("button", {
                                staticStyle: { display: "none" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return (() => void 0).apply(null, arguments)
                                  },
                                },
                              }),
                              _c(
                                "vs-button",
                                {
                                  staticClass: "btn-large",
                                  attrs: {
                                    color: "#303030",
                                    "vs-type": "filled",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.cleanData.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("dash.button.cancel")))]
                              ),
                              _vm.editedBotExists && _vm.editedBotRemovable
                                ? _c(
                                    "vs-button",
                                    {
                                      staticClass: "btn-large",
                                      attrs: {
                                        color: "#303030",
                                        "vs-type": "filled",
                                        "data-qa": "form-bot-remove",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.removeBot.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("dash.button.delete")) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.botIsValid
                                ? [
                                    !_vm.editedBotExists
                                      ? _c(
                                          "vs-button",
                                          {
                                            staticClass: "btn-large btn-img",
                                            attrs: {
                                              color: "#303030",
                                              "vs-type": "filled",
                                              button: "submit",
                                              "data-qa": "form-bot-submit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.submit("bot")
                                              },
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("dash.button.launch")
                                                )
                                              ),
                                            ]),
                                            _c("img", {
                                              attrs: {
                                                src: require("../../../assets/img/icon_launch.svg"),
                                                alt: "search",
                                              },
                                            }),
                                          ]
                                        )
                                      : _c(
                                          "vs-button",
                                          {
                                            staticClass: "btn-large",
                                            attrs: {
                                              color: "#303030",
                                              "vs-type": "filled",
                                              "data-qa": "form-bot-submit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.update.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.button.save")
                                              ) +
                                                "\n                              "
                                            ),
                                          ]
                                        ),
                                  ]
                                : [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t("dash.bots.invalidBot"),
                                          position: "right",
                                        },
                                      },
                                      [
                                        !_vm.editedBotExists
                                          ? _c(
                                              "vs-button",
                                              {
                                                staticClass:
                                                  "btn-large btn-img",
                                                attrs: {
                                                  color: "#303030",
                                                  "vs-type": "filled",
                                                  disabled: "true",
                                                  button: "submit",
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.button.launch"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../assets/img/icon_launch.svg"),
                                                    alt: "search",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large",
                                                attrs: {
                                                  color: "#303030",
                                                  "vs-type": "filled",
                                                  disabled: "true",
                                                  button: "submit",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.button.save")
                                                  ) +
                                                    "\n                                  "
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: _vm.dialog.title, active: _vm.dialog.show },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            },
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.dialog.message))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }